<template>
    <div id="MarsView">
        <MdTitleRegInfo
            v-if="!OpenInModal"
            v-bind:RegistrationInfo="PatientTitle"
            v-bind:titlePrefix="$t('modalMarsMed.MarsMed')"
            v-bind:titleRef="'titleElementMarsMed'"
            v-bind:patientCode="this.$route.params.id"
        >
        </MdTitleRegInfo>
        <div
            class="alert alert-fill-warning d-flex align-items-center m-3"
            role="alert"
            v-if="isReadOnly"
        >
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
                <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
            </div>
        </div>

        <div
            class="alert alert-fill-warning d-flex align-items-center m-3"
            role="alert"
            v-if="ViewReadOnly && !isReadOnly"
        >
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
                <span>{{ $t('modalMarsMed.EmployeeMessageType') }}</span>
            </div>
        </div>

        <div
            class="alert alert-fill-warning d-flex align-items-center m-3"
            role="alert"
            v-if="PhotoObj.marsAlerts"
        >
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
                <span>{{ PhotoObj.marsAlerts }}</span>
            </div>
        </div>

        <div class="IncidentContainerBox noNum mt-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                        <div class="card activeCard">
                            <div class="card-body">
                                <div class="d-flex align-items-start justify-content-between">
                                    <h6
                                        v-b-toggle="'InfoBoxs'"
                                        class="card-title flex-grow lower-line text-truncate"
                                        v-if="OpenInModal"
                                    >
                                        {{ PhotoObj.patientName }} - {{ PatientCode }} -
                                        {{ $t('Shared.Dob') }} {{ PhotoObj.dob }}
                                        {{ PhotoObj.ageFormatted }} - {{ $t('Shared.Weight') }}
                                        {{ PhotoObj.weight }} - {{ $t('Shared.Height') }}
                                        {{ PhotoObj.heights }}
                                    </h6>

                                    <h6
                                        v-b-toggle="'InfoBoxs'"
                                        class="card-title flex-grow lower-line text-truncate"
                                        v-else
                                    >
                                        {{ $t('Shared.Weight') }}
                                        <span v-if="RegistrationInfo.weight">{{
                                            RegistrationInfo.weight
                                        }}</span
                                        ><span v-else>{{ $t('Shared.Notdefined') }}</span> -
                                        {{ $t('Shared.Height') }}
                                        <span v-if="RegistrationInfo.heights">{{
                                            RegistrationInfo.heights
                                        }}</span
                                        ><span v-else>{{ $t('Shared.Notdefined') }}</span>
                                    </h6>
                                </div>
                                <b-collapse visible id="InfoBoxs" class="small-info ml-2"
                                    ><small>{{
                                        $t('modalMarsMed.clickTitleTextPatient')
                                    }}</small></b-collapse
                                >
                                <b-collapse id="InfoBoxs">
                                    <div class="card activeCard" v-if="OpenInModal">
                                        <div class="container-mars">
                                            <div class="card-container">
                                                <div class="card-body">
                                                    <div class="row patPhoto-container">
                                                        <div class="col-md-1 patPhoto">
                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    PhotoObj.allergies &&
                                                                        !PhotoObj.specialPrecautions &&
                                                                        !PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        PhotoObj.allergies
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !PhotoObj.allergies &&
                                                                        PhotoObj.specialPrecautions &&
                                                                        !PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    )}: ` +
                                                                        PhotoObj.specialPrecautions
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !PhotoObj.allergies &&
                                                                        !PhotoObj.specialPrecautions &&
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('Shared.MarsAlerts')}: ` +
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    PhotoObj.allergies &&
                                                                        PhotoObj.specialPrecautions &&
                                                                        !PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        PhotoObj.allergies +
                                                                        ` / ` +
                                                                        $t(
                                                                            'Shared.PatientSpecialPrecautions'
                                                                        ) +
                                                                        ': ' +
                                                                        PhotoObj.specialPrecautions
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    PhotoObj.allergies &&
                                                                        !PhotoObj.specialPrecautions &&
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        PhotoObj.allergies +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !PhotoObj.allergies &&
                                                                        PhotoObj.specialPrecautions &&
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    )}: ` +
                                                                        PhotoObj.specialPrecautions +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    PhotoObj.allergies &&
                                                                        PhotoObj.specialPrecautions &&
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        PhotoObj.allergies +
                                                                        ' / ' +
                                                                        `${$t(
                                                                            'Shared.PatientSpecialPrecautions'
                                                                        )}: ` +
                                                                        PhotoObj.specialPrecautions +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <img
                                                                v-if="PhotoObj.patientPhoto"
                                                                v-bind:src="
                                                                    'data:image/' +
                                                                        '.' +
                                                                        PhotoObj.patientPhotoExtension +
                                                                        ';base64,' +
                                                                        PhotoObj.patientPhoto
                                                                "
                                                                alt="Foto"
                                                                class="patPic img-fluid"
                                                                style="height: 100%;"
                                                            />
                                                            <img
                                                                v-if="
                                                                    (PhotoObj.patientPhoto ===
                                                                        null ||
                                                                        PhotoObj.patientPhoto ===
                                                                            '') &&
                                                                        PhotoObj.sex === 'Male'
                                                                "
                                                                src="@/assets/images/faces/nopic-male.jpg"
                                                                alt="Foto"
                                                                class="photo img-fluid"
                                                            />
                                                            <img
                                                                v-if="
                                                                    (PhotoObj.patientPhoto ===
                                                                        null ||
                                                                        PhotoObj.patientPhoto ===
                                                                            '') &&
                                                                        PhotoObj.sex === 'Female'
                                                                "
                                                                src="@/assets/images/faces/nopic-female.jpg"
                                                                alt="Foto"
                                                                class="photo img-fluid"
                                                            />
                                                        </div>
                                                        <div class="col-md-11">
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.PatientName')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        PhotoObj.patientName
                                                                    }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.PatientCode')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PatientCode }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Dob')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PhotoObj.dob }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Age')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        PhotoObj.ageFormatted
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Gender')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PhotoObj.sex }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Weight')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PhotoObj.weight }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Height')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PhotoObj.heights }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $tc('Shared.Program')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        PhotoObj.programName
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <MdPatientAllergies
                                            v-if="PatientCode"
                                            v-bind:NoUseClass="false"
                                            v-bind:ModalIdAddAllergy="'AddAllergyMars'"
                                            v-bind:VisibleAllergy="true"
                                            v-bind:AdmissionRecordId="AdmRecordId"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                            v-bind:NoValidateChanges="true"
                                        >
                                        </MdPatientAllergies>
                                        <MdPatientSpecialPrecautions
                                            v-if="PatientCode"
                                            v-bind:NoUseClass="false"
                                            v-bind:ModalIdAddSpecialPrecautions="
                                                'AddSpecialPrecautionMarsMed'
                                            "
                                            v-bind:VisibleSpecialPrecautions="true"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                            v-bind:NoValidateChanges="true"
                                        >
                                        </MdPatientSpecialPrecautions>
                                        <MdPatientMarsAlert
                                            v-if="PatientCode"
                                            v-bind:UseColumnDynamic="true"
                                            v-bind:ModalIdAddMarksAlert="'ModalMarsAlert'"
                                            v-bind:VisibleMarsAlert="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                        >
                                        </MdPatientMarsAlert>
                                        <MdPatientDiagnosis
                                            v-if="PatientCode"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:VisibleDiagnosis="true"
                                            v-bind:ModalIdDiagnosis="'ModalIdDiagMarsMed'"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                        >
                                        </MdPatientDiagnosis>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-row class="mt-2">
            <b-col md="2" sm="12">
                <!-- <MdEdit
                        v-bind:Label="$t('Nurses.DateTimeFrom')"
                        v-bind:isReadOnly="false"
                        v-bind:TypeProp="'datetime-local'"
                        v-bind:Name="'DateFrom'"
						v-bind:Id="'input_date_from'"
                        v-bind:NoValidateChanges="true"
                        v-bind:Min="'1900-01-01T00:00'"
                        v-bind:OnPressEnter="getListing"
                        v-bind:isRequired="true"
                        v-bind:isValid="IsValidDateandTimeFrom"
                        v-bind:Max="'2200-12-31T23:59'"
                        v-model="DateFromModal"/>-->
                <!--<MdDateTime
                            :Label="$t('Nurses.DateTimeFrom')"
                            Model="DateFromModal"
                            :Id="'Marsinput_date_from'"
                            :Type="'datetime'"
                            :OnPressEnter="getListing"
                            :isConfirm="false"
                            :isRequired="true"
                            :ReadOnly="false">
                        </MdDateTime>-->

                <MdDateTime
                    :Label="$t('Nurses.DateTimeFrom')"
                    :Model="DateFromModal"
                    @input="DateFromModal = $event"
                    :Id="'Marsinput_date_from'"
                    :Type="'datetime'"
                    :OnPressEnter="getListing"
                    :isRequired="true"
                    :isConfirm="false"
                    :ReadOnly="false"
                >
                </MdDateTime>
            </b-col>
            <b-col md="2" sm="12">
                <!--<MdEdit
                    v-bind:Label="$t('Nurses.DateTimeTo')"
                    v-bind:isReadOnly="false"
                    v-bind:TypeProp="'datetime-local'"
                    v-bind:isRequired="true"
                    v-bind:NoValidateChanges="true"
                    v-bind:OnPressEnter="getListing"
                    v-bind:isValid="IsValidDateandTimeTo"
                    v-bind:Min="'1900-01-01T00:00'"
                    v-bind:Max="'2200-12-31T23:59'"
                    v-model="DateToModal"/> -->
                <!--<MdDateTime
                        :Label="$t('Nurses.DateTimeTo')"
                        v-model="DateToModal"
                        :Id="'MarsDateTimeTo'"
                        :Type="'datetime'"
                        :OnPressEnter="getListing"
                        :onChange="getListing"
                        :isRequired="true"
                        :isConfirm="false"
                        :ReadOnly="false">
                    </MdDateTime>-->
                <MdDateTime
                    :Label="$t('Nurses.DateTimeTo')"
                    :Model="DateToModal"
                    @input="DateToModal = $event"
                    :Id="'Marsinput_date_to'"
                    :Type="'datetime'"
                    :OnPressEnter="getListing"
                    :isRequired="true"
                    :isConfirm="false"
                    :ReadOnly="false"
                >
                </MdDateTime>
            </b-col>
            <b-col md="2">
                <MdSelect
                    v-bind:Label="$t('Shared.Type')"
                    v-bind:Options="ModeList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:NoValidateChanges="true"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="mode"
                    v-bind:Multiple="false"
                    v-bind:IsDisabled="false"
                    :Input="ChangeDropDownMode"
                />
            </b-col>

            <b-col md="2">
                <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="StatusList"
                    v-bind:FieldDescription="'name'"
                    v-bind:Tag="'MedicationModalStatus'"
                    v-bind:FieldCode="'code'"
                    v-bind:AllowEmpty="false"
                    v-bind:RequireEvent="true"
                    v-bind:Model="Status"
                    v-bind:IsDisabled="isTypePRN"
                    :Input="ChangeDropDownStatus"
                />
            </b-col>

            <b-col md="3">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameter.SearchCriteria"
                            :readonly="false"
                            @keyup.enter="GetMedications"
                        />

                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="GetMedications"
                                v-bind:isReadOnly="false"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col lg="1" md="1" sm="12" class="align-self-end mb-2">
                <button
                    :disabled="false"
                    v-on:click="SearchMed"
                    type="button"
                    class="btn btn-primary btn-login"
                    id="btnsearchinput"
                >
                    {{ $t('Shared.Search') }}
                </button>
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <div
            v-if="showEmptyRecords"
            v-bind:style="emptyRecordsStyle"
            role="alert"
            aria-live="polite"
        >
            <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
        </div>
        <div class="zebraAccordion">
            <div class="zebraRow" v-for="(item, index) in MedList" :key="index">
                <div class="accordion" role="tablist">
                    <div class="zebraItem" v-b-toggle="'accordion-' + index">
                        <div class="container-fluid">
                            <div class="row d-flex justify-content-between align-items-center">
                                <div class="col-md-11">
                                    <div class="d-flex align-items-center">
                                        <span v-if="HaveOneGiven(index)"
                                            ><i
                                                class="ikon med-adm-given greenIconColorHeader h3"
                                                v-b-tooltip.hover
                                                :title="$t('modalMarsMed.Given')"
                                            ></i
                                        ></span>
                                        <span v-if="HaveOneNoGiven(index) && !HaveOneGiven(index)"
                                            ><i
                                                class="ikon med-adm-not-given redIconColorHeader h3"
                                                v-b-tooltip.hover
                                                :title="$t('modalMarsMed.NoGiven')"
                                            ></i
                                        ></span>
                                        <span
                                            :disabled="isReadOnly"
                                            v-if="GivenNeutro(index) && !item.needAssessment"
                                        >
                                            <i
                                                v-bind:class="{
                                                    'ikon med-adm-not-selected': !item.isHovered,
                                                    'ikon med-adm-given': item.isHovered,
                                                    'ikon h3 silverIconColorHeader':
                                                        (item.mode !== 'PRN' &&
                                                            item.marsAdministrations[0]
                                                                .expiredAdministration) ||
                                                        item.mode === 'PRN' ||
                                                        isReadOnly ||
                                                        ViewReadOnly,
                                                    'ikon h3 quickSave':
                                                        ((item.mode !== 'PRN' &&
                                                            !item.marsAdministrations[0]
                                                                .expiredAdministration) ||
                                                            item.mode === 'PRN') &&
                                                        !isReadOnly &&
                                                        !ViewReadOnly
                                                }"
                                                @mouseover="IsHover(true, index)"
                                                :style="
                                                    (item.mode !== 'PRN' &&
                                                        item.marsAdministrations[0]
                                                            .expiredAdministration) ||
                                                    isReadOnly ||
                                                    ViewReadOnly
                                                        ? 'pointer-events:NONE;'
                                                        : ''
                                                "
                                                @mouseout="IsHover(false, index)"
                                                v-on:click="
                                                    SaveAuto(
                                                        $event,
                                                        item,
                                                        'accordion-' + index,
                                                        index
                                                    )
                                                "
                                            ></i>
                                        </span>
                                        <span v-if="GivenNeutro(index) && item.needAssessment"
                                            ><i
                                                class="ikon med-adm-not-selected silverIconColorHeader ikon h3"
                                                v-b-tooltip.hover
                                                :title="$t('modalMarsMed.Neutral')"
                                            ></i
                                        ></span>

                                        <span class="mx-2">
                                            <span
                                                >{{ item.drugName }} - {{ item.qtySet }}
                                                {{ item.dispensingUOM }}
                                                <!--<i v-on:click="OpenDrugInfo(item)" class="rounded-circle tableActionBTN tableBTNtext ikon med-help h7" v-b-tooltip.hover :title="'Drug Info'"></i>-->
                                                <br />
                                                <small class="ml-2"
                                                    >{{ item.adminDate }}
                                                    <span
                                                        class="PRNlabel"
                                                        v-if="item.mode === 'PRN'"
                                                        v-b-tooltip.hover
                                                        title="Pro Re Nata (as needed)"
                                                        >PRN</span
                                                    >
                                                    <span v-if="item.mode === 'TIMED'">
                                                        <span class="opAT">@</span>
                                                        {{ item.adminTime }}
                                                    </span>

                                                    <span
                                                        class="blinkingSTAT"
                                                        v-if="item.mode === 'STAT'"
                                                        >STAT</span
                                                    >
                                                    <span
                                                        class="DrugOrderType mx-1"
                                                        v-on:click="OpenDrugInfo(item)"
                                                        >{{ $t('Shared.DrugInfo') }}</span>

                                                    <span
                                                        class="DrugOrderType mx-1"
                                                        v-on:click="OpenDrugInteraction(item)"
                                                        >{{ $t('DrugOrdersInboxRightBar.DrugInteraction') }}
                                                    </span>
                                                </small>
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-1">
                                    <div class="pull-right">
                                        <i
                                            :class="
                                                getStatus(item.mode, index) === '4_NO_PEND_ADM'
                                                    ? 'ikon med-adm-not-pending silverIconColorHeader h3'
                                                    : getStatus(item.mode, index) ===
                                                      '3_PRIOR_TO_ADM'
                                                    ? 'ikon med-adm-prior greenIconColorHeader h3'
                                                    : getStatus(item.mode, index) ===
                                                      '2_CLOSE_TO_ADM'
                                                    ? 'ikon med-adm-close orangeIconColorHeader h3'
                                                    : 'ikon med-adm-overdue redIconColorHeader h3'
                                            "
                                            v-b-tooltip.hover
                                            :title="getTitle(item.mode, index)"
                                        >
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-card no-body>
                        <b-collapse
                            :id="'accordion-' + index"
                            accordion="my-accordion"
                            v-model="item.isOpenCollapse"
                            :ref="'accordion-' + index"
                            role="tabpanel"
                            @show="ImageDrugName(item)"
                        >
                            <b-card-body class="accordionContent pt-3">
                                <b-alert
                                    show
                                    class="alert alert-fill-warning"
                                    v-if="
                                        item.isHighAlert ||
                                            item.isLookAlikeSoundAlike ||
                                            item.allergicToDrug
                                    "
                                >
                                    <h5 class="alert-heading mt-2">
                                        <i
                                            class="mdi mdi-alert me-2"
                                            style="font-size: 1.5rem;"
                                        ></i>
                                        <span v-if="HasMoreThanOneAlert(index)"
                                            >{{ $t('modalMarsMed.Alerts')
                                            }}<span class="d-none d-sm-inline">
                                                {{ $t('modalMarsMed.FoundMed') }}</span
                                            >!</span
                                        >
                                        <span v-else
                                            >{{ $t('Shared.Alert')
                                            }}<span class="d-none d-sm-inline">
                                                {{ $t('modalMarsMed.FoundMed') }}</span
                                            >!</span
                                        >
                                    </h5>
                                    <hr />
                                    <ul class="ml-2">
                                        <li v-if="item.isHighAlert">
                                            {{ $t('modalMarsMed.HighAlert') }}
                                        </li>
                                        <li v-if="item.isLookAlikeSoundAlike">
                                            {{ $t('modalMarsMed.LookAlikeSoundAlike') }}
                                        </li>
                                        <li v-if="item.allergicToDrug">
                                            {{ $t('modalMarsMed.allergicToDrug') }}
                                        </li>
                                    </ul>
                                </b-alert>

                                <div class="card activeCard">
                                    <div class="container-mars mt-3">
                                        <div class="card-container">
                                            <div class="card-body">
                                                <div class="row patPhoto-container">
                                                    <div class="col-md-2 patPhoto">
                                                        <i
                                                            id="rm-allergic"
                                                            v-if="
                                                                PhotoObj.allergies &&
                                                                    !PhotoObj.specialPrecautions &&
                                                                    !PhotoObj.marsAlerts
                                                            "
                                                            class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor"
                                                            v-b-tooltip.hover="
                                                                `${$t('RigthBar.ALLERGIC')}: ` +
                                                                    PhotoObj.allergies
                                                            "
                                                            variant="primary"
                                                        >
                                                        </i>

                                                        <i
                                                            id="rm-allergic"
                                                            v-if="
                                                                !PhotoObj.allergies &&
                                                                    PhotoObj.specialPrecautions &&
                                                                    !PhotoObj.marsAlerts
                                                            "
                                                            class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor"
                                                            v-b-tooltip.hover="
                                                                `${$t(
                                                                    'Shared.PatientSpecialPrecautions'
                                                                )}: ` + PhotoObj.specialPrecautions
                                                            "
                                                            variant="primary"
                                                        >
                                                        </i>

                                                        <i
                                                            id="rm-allergic"
                                                            v-if="
                                                                !PhotoObj.allergies &&
                                                                    !PhotoObj.specialPrecautions &&
                                                                    PhotoObj.marsAlerts
                                                            "
                                                            class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor"
                                                            v-b-tooltip.hover="
                                                                `${$t('Shared.MarsAlerts')}: ` +
                                                                    PhotoObj.marsAlerts
                                                            "
                                                            variant="primary"
                                                        >
                                                        </i>

                                                        <i
                                                            id="rm-allergic"
                                                            v-if="
                                                                PhotoObj.allergies &&
                                                                    PhotoObj.specialPrecautions &&
                                                                    !PhotoObj.marsAlerts
                                                            "
                                                            class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor"
                                                            v-b-tooltip.hover="
                                                                `${$t('RigthBar.ALLERGIC')}: ` +
                                                                    PhotoObj.allergies +
                                                                    ` / ` +
                                                                    $t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    ) +
                                                                    ': ' +
                                                                    PhotoObj.specialPrecautions
                                                            "
                                                            variant="primary"
                                                        >
                                                        </i>

                                                        <i
                                                            id="rm-allergic"
                                                            v-if="
                                                                PhotoObj.allergies &&
                                                                    !PhotoObj.specialPrecautions &&
                                                                    PhotoObj.marsAlerts
                                                            "
                                                            class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor"
                                                            v-b-tooltip.hover="
                                                                `${$t('RigthBar.ALLERGIC')}: ` +
                                                                    PhotoObj.allergies +
                                                                    ` / ` +
                                                                    $t('Shared.MarsAlerts') +
                                                                    ': ' +
                                                                    PhotoObj.marsAlerts
                                                            "
                                                            variant="primary"
                                                        >
                                                        </i>

                                                        <i
                                                            id="rm-allergic"
                                                            v-if="
                                                                !PhotoObj.allergies &&
                                                                    PhotoObj.specialPrecautions &&
                                                                    PhotoObj.marsAlerts
                                                            "
                                                            class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor"
                                                            v-b-tooltip.hover="
                                                                `${$t(
                                                                    'Shared.PatientSpecialPrecautions'
                                                                )}: ` +
                                                                    PhotoObj.specialPrecautions +
                                                                    ` / ` +
                                                                    $t('Shared.MarsAlerts') +
                                                                    ': ' +
                                                                    PhotoObj.marsAlerts
                                                            "
                                                            variant="primary"
                                                        >
                                                        </i>

                                                        <!--<img  src="@/assets/images/faces/nopic-meds.jpg" alt="Foto" class="photo img-fluid">-->

                                                        <!-- Bootstrap Carousel -->
                                                        <!-- <div v-if="images.length > 0" id="imageCarousel" class="carousel slide" data-bs-ride="carousel">
                                                    <div class="carousel-indicators">
                                                        <button v-for="(image, index) in images" :key="index" type="button"
                                                        data-bs-target="#imageCarousel" :data-bs-slide-to="index"
                                                        :class="index === 0 ? 'active' : ''"></button>
                                                </div>

                                                <div class="carousel-inner">
                                                        <div v-for="(image, index) in images" :key="index" class="carousel-item" :class="index === 0 ? 'active' : ''">
                                                        <img :src="image.url" class="d-block w-100 carousel-img" alt="Medication Image">
                                                        <div class="carousel-caption">
                                                            <p>{{ image.description }}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button class="carousel-control-prev" type="button" data-bs-target="#imageCarousel" data-bs-slide="prev">
                                                    <span class="carousel-control-prev-icon"></span>
                                                </button>
                                                <button class="carousel-control-next" type="button" data-bs-target="#imageCarousel" data-bs-slide="next">
                                                    <span class="carousel-control-next-icon"></span>
                                                </button>
                                                </div>-->

                                                        <div class="carouselPic">
                                                            <b-carousel
                                                                :id="'Carousel_' + index"
                                                                v-model="slide"
                                                                :interval="4000"
                                                                controls
                                                                :show-controls="false"
                                                                indicators
                                                                background="#ababab"
                                                                @sliding-start="onSlideStart"
                                                                @sliding-end="onSlideEnd"
                                                                style="height: 150px;"
                                                            >
                                                                <b-carousel-slide
                                                                    v-if="images.length === 0"
                                                                    img-src="@/assets/images/faces/nopic-meds.jpg"
                                                                    img-class="carousel-img-fixed NoPrevNext"
                                                                    style="height: 150px; object-fit: cover;"
                                                                >
                                                                </b-carousel-slide>

                                                                <b-carousel-slide
                                                                    v-for="(img,
                                                                    indexImg) in images"
                                                                    :key="indexImg"
                                                                    :img-src="img.url"
                                                                    :caption="item.name"
                                                                    :id="
                                                                        'Slide_' +
                                                                            index +
                                                                            '_' +
                                                                            indexImg +
                                                                            img.code
                                                                    "
                                                                    img-class="carousel-img-fixed"
                                                                    style="height: 150px; object-fit: cover;"
                                                                >
                                                                </b-carousel-slide>
                                                            </b-carousel>
                                                        </div>
                                                        <div class="carousel-description">
                                                            <p class="text-center">
                                                                {{
                                                                    images[slide] &&
                                                                    images[slide].description
                                                                        ? images[slide].description
                                                                        : 'No description available'
                                                                }}
                                                            </p>
                                                        </div>
                                                        <!--
                    <b-carousel-slide v-for="(img, indexImg) in images" :key="indexImg"
                        :img-src="img.url"
                        :caption="item.name"
                        :text="img.description"
                        :id="'Slide_'+index+'_'+indexImg+img.code"
                        >
                    </b-carousel-slide>
                </b-carousel>-->

                                                        <!-- No Available Image
                   <div class="no-image" v-else>
                        <img  src="@/assets/images/faces/nopic-meds.jpg" alt="No available image" class="photo img-fluid"> <p>No Available Image</p>
                    </div>-->
                                                    </div>

                                                    <div class="col-md-10 resetFontSize">
                                                        <div class="row">
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.qtySet"
                                                            >
                                                                <small>{{
                                                                    $t('Shared.Dosage')
                                                                }}</small
                                                                ><br />
                                                                <b
                                                                    >{{ item.qtySet }}
                                                                    {{ item.dispensingUOM }}</b
                                                                >
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small>{{
                                                                    $t('Shared.Dosage')
                                                                }}</small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>

                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.dailyQTYSet"
                                                            >
                                                                <span
                                                                    ><small>{{
                                                                        item.mode !== 'PRN'
                                                                            ? $t(
                                                                                  'Shared.DailyAmount'
                                                                              )
                                                                            : $t(
                                                                                  'modalMarsMed.MaximumDailyQTYSet'
                                                                              )
                                                                    }}</small
                                                                    ><br
                                                                /></span>
                                                                <b
                                                                    >{{ item.dailyQTYSet }}
                                                                    {{ item.dispensingUOM }}</b
                                                                >
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small
                                                                    >{{
                                                                        $t('Shared.DailyAmount')
                                                                    }} </small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>

                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.diagnosticName"
                                                            >
                                                                <small>{{
                                                                    $t('Shared.Diagnosis')
                                                                }}</small
                                                                ><br />
                                                                <b>{{ item.diagnosticName }}</b>
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small>{{
                                                                    $t('Shared.Diagnosis')
                                                                }}</small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>

                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.indicationName"
                                                            >
                                                                <small>{{
                                                                    $t('modalMarsMed.Indication')
                                                                }}</small
                                                                ><br />
                                                                <b>{{ item.indicationName }}</b>
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small>{{
                                                                    $t('modalMarsMed.Indication')
                                                                }}</small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.sig"
                                                            >
                                                                <small>{{ $t('Shared.Sig') }}</small
                                                                ><br />
                                                                <b>{{ item.sig }}</b>
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small>{{ $t('Shared.Sig') }}</small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>

                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.prescriberNotes"
                                                            >
                                                                <small>{{
                                                                    $t('Shared.PrescriberNotes')
                                                                }}</small
                                                                ><br />
                                                                <b
                                                                    ><b-spinner
                                                                        class="mr-1"
                                                                        small
                                                                        label="Small Spinner"
                                                                        type="grow"
                                                                        variant="warning"
                                                                    ></b-spinner
                                                                    >{{ item.prescriberNotes }}</b
                                                                >
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small>{{
                                                                    $t('Shared.PrescriberNotes')
                                                                }}</small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>

                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="item.orderByName"
                                                            >
                                                                <small
                                                                    >{{
                                                                        $t('Shared.Prescriber')
                                                                    }} </small
                                                                ><br />
                                                                <b>{{ item.orderByName }}</b>
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else
                                                            >
                                                                <small
                                                                    >{{
                                                                        $t('Shared.Prescriber')
                                                                    }} </small
                                                                ><br />
                                                                <b>{{ $t('Shared.Notdefined') }}</b>
                                                            </div>

                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-if="
                                                                    item.isPatientOwnMedication &&
                                                                        !isNRC
                                                                "
                                                            >
                                                                <small
                                                                    >{{
                                                                        $t(
                                                                            'modalMarsMed.PatientOwnMedication'
                                                                        )
                                                                    }} </small
                                                                ><br />
                                                                <b>{{
                                                                    item.isPatientOwnMedication
                                                                }}</b>
                                                            </div>
                                                            <div
                                                                class="col-md-3 text-muted p-item"
                                                                v-else-if="
                                                                    !item.isPatientOwnMedication &&
                                                                        !isNRC
                                                                "
                                                            >
                                                                <small
                                                                    >{{
                                                                        $t(
                                                                            'modalMarsMed.PatientOwnMedication'
                                                                        )
                                                                    }} </small
                                                                ><br />
                                                                <b>{{ $t('Shared.No') }}</b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="alert alert-fill-warning d-flex align-items-center m-3"
                                    role="alert"
                                    v-if="maximumQuantityPRNInvalid(item)"
                                >
                                    <div class="flex-grow-1">
                                        <span>{{
                                            $t('modalMarsMed.PRNMaximumQuantityInvalid')
                                        }}</span>
                                    </div>
                                </div>

                                <div
                                    v-if="item.readOnly"
                                    class="alert alert-fill-warning d-flex flex-column flex-md-row align-items-center m-2"
                                    role="alert"
                                >
                                    <i
                                        class="ikon med-adm-not-selected me-2"
                                        style="font-size: 1.5rem;"
                                    ></i>
                                    <div
                                        class="flex-grow-1 d-flex flex-column align-items-center align-items-md-start text-center text-md-left"
                                    >
                                        <span> {{ item.readOnlyReason }} </span>
                                    </div>
                                </div>

                                <div
                                    v-for="(itemchild, indexchild) in item.marsAdministrations"
                                    v-bind:key="GetItemChildPrefix(item, itemchild)"
                                >
                                    <b-button-group
                                        class="ml-3 groupActions whiteBtn"
                                        v-if="item.mode === 'PRN'"
                                    >
                                        <b-button
                                            v-b-tooltip.hover
                                            :disabled="
                                                isReadOnly ||
                                                    ViewReadOnly ||
                                                    !CanAddNewPRN(item) ||
                                                    pendingChanges
                                            "
                                            v-on:click="AddAdm(item)"
                                            :title="$t('modalMarsMed.AddAdm')"
                                            size="sm"
                                            variant="light"
                                        >
                                            <b-icon
                                                icon="plus-circle-fill"
                                                aria-hidden="true"
                                            ></b-icon>
                                        </b-button>

                                        <b-button
                                            v-b-tooltip.hover
                                            v-on:click="DeleteAdm(item, itemchild, indexchild)"
                                            :disabled="
                                                isReadOnly ||
                                                    ViewReadOnly ||
                                                    !(
                                                        itemchild.isNewAdm &&
                                                        item.marsAdministrations.length > 1
                                                    )
                                            "
                                            :title="$t('modalMarsMed.DelAdm')"
                                            size="sm"
                                            variant="light"
                                        >
                                            <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <!--
                    <div
                        class="d-flex align-items-center ml-2"
                        role="alert"
                        v-if="!((item.needAssessment && !VerifyAllAssessment(item,itemchild.assessmentDetails)) || isReadOnly  || ViewReadOnly || itemchild.DisaBledBtnAdm) || itemchild.given === null">
                        <i
                            v-b-tooltip.hover
                            class="mdi mdi-alert-circle"
                            :title="itemchild.given == null ? $t('modalMarsMed.PRMPendingAssign') : $t('modalMarsMed.PRMPendingChanges')" size="sm" variant="light"
                            style="font-size: 1.1rem; color: #f79f07 !important">
                        </i>
                    </div>
                    -->
                                    </b-button-group>

                                    <b-card bg-variant="white">
                                        <b-row v-if="item.needAssessment">
                                            <b-col md="12">
                                                <div
                                                    class="alert alert-fill-warning d-flex flex-column flex-md-row align-items-center m-2"
                                                    role="alert"
                                                >
                                                    <i
                                                        class="ikon med-adm-not-selected me-2"
                                                        style="font-size: 1.5rem;"
                                                    ></i>
                                                    <div
                                                        class="flex-grow-1 d-flex flex-column align-items-center align-items-md-start text-center text-md-left"
                                                    >
                                                        <span v-if="item.needAssessment">
                                                            {{
                                                                GetNeedAssessmentLabel(
                                                                    item,
                                                                    itemchild
                                                                )
                                                            }}
                                                        </span>
                                                    </div>
                                                    <b-dropdown
                                                        id="dropdown-right"
                                                        :text="$t('modalMarsMed.Assess')"
                                                        variant="primary"
                                                        class="mt-2 mt-md-0 ms-md-auto"
                                                    >
                                                        <b-dropdown-item
                                                            :disabled="isReadOnly"
                                                            v-for="(assessmentItem,
                                                            assessmentIndex) in itemchild.assessmentDetails"
                                                            :key="
                                                                assessmentItem.templateCode +
                                                                    assessmentIndex
                                                            "
                                                            v-bind:value="
                                                                assessmentItem.templateCode
                                                            "
                                                            v-on:click="
                                                                showModalOutCome(
                                                                    assessmentItem,
                                                                    item,
                                                                    itemchild,
                                                                    index,
                                                                    indexchild,
                                                                    assessmentIndex
                                                                )
                                                            "
                                                        >
                                                            <div
                                                                v-if="assessmentItem.metAssessment"
                                                            >
                                                                <i
                                                                    class="ikon med-status-complete h3"
                                                                    v-b-tooltip.hover
                                                                    :title="
                                                                        $t(
                                                                            'modalMarsMed.AssessmentCompleted'
                                                                        )
                                                                    "
                                                                ></i>
                                                                {{
                                                                    assessmentItem.templateDescription
                                                                }}
                                                            </div>
                                                            <div v-else>
                                                                <i
                                                                    class="ikon med-pen h3"
                                                                    v-b-tooltip.hover
                                                                    :title="
                                                                        $t(
                                                                            'modalMarsMed.AssessmentNotCompleted'
                                                                        )
                                                                    "
                                                                ></i>
                                                                {{
                                                                    assessmentItem.templateDescription
                                                                }}
                                                            </div>
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                            </b-col>
                                        </b-row>

                                        <div
                                            class="alert alert-fill-warning d-flex align-items-center m-3"
                                            role="alert"
                                            v-if="itemchild.expiredAdministration"
                                        >
                                            <i
                                                class="mdi mdi-alert-circle me-2"
                                                style="font-size: 1.5rem;"
                                            ></i>
                                            <div class="flex-grow-1">
                                                <span>{{
                                                    $t('modalMarsMed.ExpiredAdministration')
                                                }}</span>
                                            </div>
                                        </div>

                                        <b-row>
                                            <b-col
                                                md="auto"
                                                class="d-flex justify-content-center align-items-center"
                                                v-if="isUAE"
                                            >
                                                <!--<span v-if="isUAE" class="StockInfo" v-on:click="StockInfo(item.recordId,item.drugCode,item.qtySet,item.mode,item.dailyQTYSet,item.dailyQTYUsed)">Enter Stock</span>-->
                                                <MdButton
                                                    v-bind:Label="'Enter Stock Info'"
                                                    v-bind:ClassProp="
                                                        'btn btn-primary mt-2 btn-login btn-block'
                                                    "
                                                    v-on:click="
                                                        StockInfo(
                                                            item.recordId,
                                                            item.drugCode,
                                                            item.qtySet,
                                                            item.mode,
                                                            item.dailyQTYSet,
                                                            item.dailyQTYUsed,
                                                            index,
                                                            indexchild,
                                                            itemchild
                                                        )
                                                    "
                                                    v-bind:Name="'btn_Mars_StockInfo'"
                                                >
                                                </MdButton>
                                            </b-col>

                                            <b-col md="auto" class="align-self-center text-center">
                                                <b-button-toolbar class="mt-2">
                                                    <b-button-group class="mr-1 giveMeds">
                                                        <b-tooltip
                                                            :target="'GivenId' + index"
                                                            placement="top"
                                                            :delay="{ show: 500, hide: 0 }"
                                                        >
                                                            {{ $t('modalMarsMed.Given') }}
                                                        </b-tooltip>

                                                        <b-tooltip
                                                            :target="'UndoGivenId' + index"
                                                            placement="top"
                                                            :delay="{ show: 500, hide: 0 }"
                                                        >
                                                            {{ $t('modalMarsMed.UndoGive') }}
                                                        </b-tooltip>

                                                        <b-tooltip
                                                            :target="'UndoNoGiveId' + index"
                                                            placement="top"
                                                            :delay="{ show: 500, hide: 0 }"
                                                        >
                                                            {{ $t('modalMarsMed.UndoNoGive') }}
                                                        </b-tooltip>

                                                        <b-tooltip
                                                            :target="'NoGivenId' + index"
                                                            placement="top"
                                                            :delay="{ show: 500, hide: 0 }"
                                                        >
                                                            {{ $t('modalMarsMed.NoGiven') }}
                                                        </b-tooltip>

                                                        <span
                                                            :id="'GivenId' + index"
                                                            class="d-inline-block"
                                                            tabindex="0"
                                                        >
                                                            <b-button
                                                                id="GivenId"
                                                                :disabled="
                                                                    isReadOnly ||
                                                                        itemchild.disabledGiven ||
                                                                        itemchild.given ||
                                                                        itemchild.expiredAdministration ||
                                                                        ViewReadOnly ||
                                                                        !VerifyAllAssessment(
                                                                            item,
                                                                            itemchild.assessmentDetails
                                                                        )
                                                                "
                                                                v-if="
                                                                    itemchild.given === null ||
                                                                        itemchild.given
                                                                "
                                                                v-on:click="
                                                                    Give(
                                                                        item,
                                                                        itemchild,
                                                                        index,
                                                                        indexchild
                                                                    )
                                                                "
                                                                class="greenMed"
                                                            >
                                                                <i class="ikon med-adm-given"></i>
                                                            </b-button>
                                                        </span>
                                                        <span
                                                            :id="'UndoGivenId' + index"
                                                            class="d-inline-block"
                                                            tabindex="0"
                                                        >
                                                            <b-button
                                                                :disabled="
                                                                    isReadOnly /*|| itemchild.expiredAdministration*/ ||
                                                                        ViewReadOnly ||
                                                                        !VerifyAllAssessment(
                                                                            item,
                                                                            itemchild.assessmentDetails
                                                                        )
                                                                "
                                                                v-if="
                                                                    itemchild.given !== null &&
                                                                        itemchild.given
                                                                "
                                                                v-on:click="
                                                                    NoGiveUndo(
                                                                        item,
                                                                        itemchild,
                                                                        index,
                                                                        indexchild
                                                                    )
                                                                "
                                                                class="redMed undoMedRight"
                                                            >
                                                                <i class="ikon med-adm-undo"></i>
                                                            </b-button>
                                                        </span>
                                                        <span
                                                            :id="'UndoNoGiveId' + index"
                                                            class="d-inline-block"
                                                            tabindex="0"
                                                        >
                                                            <b-button
                                                                :disabled="
                                                                    isReadOnly ||
                                                                        /* itemchild.expiredAdministration ||*/ ViewReadOnly /*|| !VerifyAllAssessment(item,itemchild.assessmentDetails)*/
                                                                "
                                                                v-if="
                                                                    itemchild.given !== null &&
                                                                        !itemchild.given
                                                                "
                                                                v-on:click="
                                                                    GiveUndo(
                                                                        item,
                                                                        itemchild,
                                                                        index,
                                                                        indexchild
                                                                    )
                                                                "
                                                                class="greenMed undoMedLeft"
                                                            >
                                                                <i class="ikon med-adm-undo"></i>
                                                            </b-button>
                                                        </span>
                                                        <span
                                                            :id="'NoGivenId' + index"
                                                            class="d-inline-block"
                                                            tabindex="0"
                                                        >
                                                            <b-button
                                                                :disabled="
                                                                    isReadOnly ||
                                                                    itemchild.disabledNoGiven ||
                                                                    itemchild.given ===
                                                                        false /*|| itemchild.expiredAdministration*/ ||
                                                                        ViewReadOnly /*|| !VerifyAllAssessment(item,itemchild.assessmentDetails)*/
                                                                "
                                                                v-if="
                                                                    itemchild.given === null ||
                                                                        !itemchild.given
                                                                "
                                                                v-on:click="
                                                                    NoGive(
                                                                        item,
                                                                        itemchild,
                                                                        index,
                                                                        indexchild
                                                                    )
                                                                "
                                                                class="redMed"
                                                            >
                                                                <i
                                                                    class="ikon med-adm-not-given"
                                                                ></i>
                                                            </b-button>
                                                        </span>
                                                    </b-button-group>
                                                </b-button-toolbar>
                                            </b-col>

                                            <b-col md="4">
                                                <MdEdit
                                                    v-bind:Label="$t('Shared.GivenTime')"
                                                    v-bind:TypeProp="'time'"
                                                    v-bind:IdButton="
                                                        'btn_save_givenTime_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:Name="
                                                        'givenTime_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:Obj1="itemchild"
                                                    v-bind:isReadOnly="
                                                        /*(item.needAssessment && !VerifyAllAssessment(item,itemchild.assessmentDetails)) ||*/ isReadOnly ||
                                                            ViewReadOnly ||
                                                            itemchild.given ==
                                                                null /*|| !pendingChanges*/
                                                    "
                                                    v-bind:Id="
                                                        'givenTime_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    :ref="
                                                        'givenTime_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:invalidMessage="
                                                        itemchild.givenTimeInvalidFeedbackMessage
                                                    "
                                                    v-model="itemchild.givenTime"
                                                >
                                                </MdEdit>
                                            </b-col>

                                            <b-col
                                                md="3"
                                                v-show="
                                                    itemchild.given === null ||
                                                        itemchild.given === true
                                                "
                                            >
                                                <MdEdit
                                                    v-bind:Label="
                                                        $t('modalMarsMed.GivenQuantity') +
                                                            ' (' +
                                                            item.dispensingUOM +
                                                            ')'
                                                    "
                                                    v-bind:TypeProp="'number'"
                                                    v-model="itemchild.givenQTY"
                                                    v-bind:Min="'0'"
                                                    v-bind:Obj1="itemchild"
                                                    v-bind:IdButton="
                                                        'btn_save_marsadm' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:Max="'9999'"
                                                    v-bind:isReadOnly="
                                                        (item.needAssessment &&
                                                            !VerifyAllAssessment(
                                                                item,
                                                                itemchild.assessmentDetails
                                                            )) ||
                                                            itemchild.given !== true ||
                                                            isReadOnly ||
                                                            itemchild.expiredAdministration ||
                                                            ViewReadOnly ||
                                                            PharmacyOption.showMARSStockInfo /*|| !pendingChanges*/
                                                    "
                                                    v-bind:Id="
                                                        'givenQTY_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:Name="
                                                        'givenQTY_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                >
                                                </MdEdit>
                                            </b-col>

                                            <b-col md="3" v-show="itemchild.given === false">
                                                <MdSelect
                                                    v-bind:Label="
                                                        $t('modalMarsMed.AdministrationStatus')
                                                    "
                                                    data-field="therapistcode"
                                                    v-bind:Options="ReasonList"
                                                    v-bind:IdButton="
                                                        'btn_save_marsadm' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:FieldDescription="'name'"
                                                    v-bind:FieldCode="'code'"
                                                    :IsDisabled="
                                                        /*(item.needAssessment && !VerifyAllAssessment(item,itemchild.assessmentDetails)) ||*/ itemchild.given ||
                                                            isReadOnly ||
                                                            ViewReadOnly /*|| !pendingChanges*/
                                                    "
                                                    v-bind:Model="itemchild.reasonCodeModel"
                                                    v-bind:UseParamsAux="true"
                                                    v-bind:UseResetModel="true"
                                                    v-bind:AuxParam="itemchild"
                                                    :Input="ChangeDropDownReason"
                                                    v-bind:Name="
                                                        'reasonCodeModel_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    :ref="
                                                        'reasonCodeModel_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col md="12">
                                                <div
                                                    :data-label="
                                                        $t('modalMarsMed.AdministrationNotes')
                                                    "
                                                    class="textlabel"
                                                ></div>
                                                <MdMemo
                                                    v-bind:TypeProp="'text'"
                                                    v-bind:Name="
                                                        'administrationNotes_' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:Obj1="itemchild"
                                                    v-bind:IdButton="
                                                        'btn_save_marsadm' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:Rows="'3'"
                                                    v-bind:isReadOnly="
                                                        /*(item.needAssessment && !VerifyAllAssessment(item,itemchild.assessmentDetails)) ||*/ isReadOnly ||
                                                            ViewReadOnly ||
                                                            itemchild.given ==
                                                                null /*|| !pendingChanges*/
                                                    "
                                                    v-bind:MaxRows="'6'"
                                                    v-model="itemchild.administrationNotes"
                                                    v-bind:Tag="'administrationNotes'"
                                                >
                                                </MdMemo>
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col md="12" class="mt-3 text-right">
                                                <MdButton
                                                    v-on:click="
                                                        SaveAdministration(
                                                            item,
                                                            itemchild,
                                                            'accordion-' + index,
                                                            index,
                                                            indexchild
                                                        )
                                                    "
                                                    v-bind:isReadOnly="
                                                        /*(item.needAssessment && !VerifyAllAssessment(item,itemchild.assessmentDetails)) ||*/ isReadOnly ||
                                                            ViewReadOnly ||
                                                            itemchild.given === null ||
                                                            itemchild.DisaBledBtnAdm
                                                    "
                                                    v-bind:Label="$t('modalMarsMed.Administration')"
                                                    v-bind:Name="
                                                        'btn_save_marsadm' +
                                                            GetItemChildPrefix(item, itemchild)
                                                    "
                                                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                                                />
                                            </b-col>
                                        </b-row>
                                        <br
                                            v-if="
                                                (itemchild.reviewedByName &&
                                                    itemchild.reviewedByName.trim() !== '') ||
                                                    (itemchild.reviewedOn &&
                                                        itemchild.reviewedOn.trim() !== '')
                                            "
                                        />
                                        <div
                                            class="mt-2"
                                            v-if="
                                                (itemchild.reviewedByName &&
                                                    itemchild.reviewedByName.trim() !== '') ||
                                                    (itemchild.reviewedOn &&
                                                        itemchild.reviewedOn.trim() !== '')
                                            "
                                        >
                                            <div
                                                class="d-sm-flex justify-content-center justify-content-sm-between"
                                            >
                                                <span
                                                    class="text-muted text-center italic text-sm-left d-block d-sm-inline-block"
                                                >
                                                    <span
                                                        >{{
                                                            $t('modalMarsMed.ReviewedByName')
                                                        }}:</span
                                                    >
                                                    <b>{{ itemchild.reviewedByName }}</b> ///
                                                    <span
                                                        >{{ $t('modalMarsMed.ReviewedOn') }}:</span
                                                    >
                                                    <b>{{ itemchild.reviewedOn }}</b>
                                                </span>
                                            </div>
                                        </div>
                                    </b-card>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>

        <div class="row mt-4" dir="ltr">
            <div class="my-1 col-sm-7 col-md-6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @change="onChange"
                    pills
                    size="lg"
                ></b-pagination>
            </div>
            <div align="right" class="mr-2 col">
                {{ $t('Shared.Show') }}
                <b-form-select
                    v-model="perPage"
                    :options="options"
                    size="sm"
                    id="perPageSelect"
                    v-bind:style="perPageStyle"
                    @change="perPageChange"
                >
                </b-form-select>
                {{ $t('Shared.Of') }} {{ totalRows }}
            </div>
        </div>

        <MdPasswordDlg
            v-if="showSignPassword"
            v-bind:Type="'Sign'"
            v-bind:Obj1="Obj1"
            v-bind:Obj2="Obj2"
            v-bind:EmployeeCode="this.$store.state.employeeCode"
            @getModalPassword="onModalPasswordResult($event)"
        >
        </MdPasswordDlg>

        <MdPatientVitalSingOutCome
            v-if="activeModalVitalSign"
            v-bind:ModalId="PatientVitalId"
            v-bind:PatientCode="this.PatientCode"
            v-bind:TitleWindow="outComeTitle"
            v-bind:outComeCode="outComeCode"
            v-bind:MarsParam="MarsParam"
            v-bind:ForUsefromMars="true"
            v-bind:ComponentKind="'Memo'"
            v-bind:NotOpenByDefault="false"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCancel="onCancel($event)"
        >
        </MdPatientVitalSingOutCome>

        <MdGenericOutCome
            v-if="activateModalGeneric"
            v-bind:ModalId="GenericId"
            v-bind:TitleWindow="outComeTitle"
            v-bind:NotOpenByDefault="false"
            v-bind:ForUsefromMars="true"
            v-bind:MarsParam="MarsParam"
            v-bind:outComeCode="outComeCode"
            v-bind:outComeDescription="outComeDescription"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCancel="onCancel($event)"
        >
        </MdGenericOutCome>

        <MdPatientAllergiesOutCome
            v-if="activateModalAllergies"
            v-bind:ModalId="AllergyId"
            v-bind:PatientCode="this.PatientCode"
            v-bind:NotOpenByDefault="false"
            v-bind:ForUsefromMars="true"
            v-bind:outComeCode="outComeCode"
            v-bind:MarsParam="MarsParam"
            v-bind:TitleWindow="outComeTitle"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCancel="onCancel($event)"
        >
        </MdPatientAllergiesOutCome>

        <MdPainAssessmentModalListing
            v-if="activateModalPainAssessmentList"
            v-bind:ModalId="AssessmentModalId"
            v-bind:RecordId="RecordId"
            v-bind:PatientCode="this.PatientCode"
            v-bind:NotOpenByDefault="false"
            v-bind:outComeCode="outComeCode"
            v-bind:ForUsefromMars="true"
            v-bind:MarsParam="MarsParam"
            v-bind:TitleWindow="outComeTitle"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCancel="onCancel($event)"
        >
        </MdPainAssessmentModalListing>

        <MdHighAlertAssessmentNotes
            v-if="activateModalHighAlertAssessmentNotes"
            v-bind:ModalId="AssessmentModalId"
            v-bind:RecordId="RecordId"
            v-bind:RecNo="RecNo"
            v-bind:PatientCode="this.PatientCode"
            v-bind:NotOpenByDefault="false"
            v-bind:outComeCode="outComeCode"
            v-bind:ForUsefromMars="true"
            v-bind:MarsParam="MarsParam"
            v-bind:TitleWindow="'High Alert Assessment Notes'"
            @getCodeConditionOK="onCodeConditionOkEmpty($event)"
            @getCancel="onCancel($event)"
        >
        </MdHighAlertAssessmentNotes>

        <MdInjectionAssessmentNotes
            v-if="activateModalInjectionAssessmentNotes"
            v-bind:ModalId="AssessmentModalId"
            v-bind:RecordId="RecordId"
            v-bind:RecNo="RecNo"
            v-bind:PatientCode="this.PatientCode"
            v-bind:NotOpenByDefault="false"
            v-bind:outComeCode="outComeCode"
            v-bind:ForUsefromMars="true"
            v-bind:MarsParam="MarsParam"
            v-bind:TitleWindow="'High Alert Assessment Notes'"
            @getCodeConditionOK="onCodeConditionOkEmpty($event)"
            @getCancel="onCancel($event)"
        >
        </MdInjectionAssessmentNotes>

        <BaseModal
            v-if="VisibleModalStockInfo"
            ModalId="'ModalIdStockInfoMars'"
            :HideModalFun="HideModalStockInfo"
            :TitleWindow="$t('modalMarsMed.StockInfo')"
            :width="'85%'"
            :height="'auto'"
            :buttons="[
                { text: 'Cancel', variant: 'secondary', action: 'Close' },
                { text: 'Ok', variant: 'primary', action: OKClickStockInfo }
            ]"
            @Close="CloseStockInfo"
        >
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-row>
                    <b-col md="2" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Location')"
                            v-bind:Options="LocationList"
                            v-bind:FieldDescription="'description'"
                            v-bind:Tag="'MedicationModalStockInfoLocation'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="false"
                            v-bind:RequireEvent="true"
                            v-bind:Model="Location"
                            v-bind:IsDisabled="false"
                            :Input="ChangeDropDownStockInfoLocation"
                        />
                    </b-col>
                    <b-col md="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.DrugName')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'DrugName'"
                            v-bind:isReadOnly="true"
                            v-model="DrugName"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="2" sm="12">
                        <MdEdit
                            v-bind:Label="'Availability'"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'Availability'"
                            v-bind:isReadOnly="true"
                            v-model="Availability"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="auto" sm="12">
                        <MdEdit
                            v-bind:Label="'Total QTY To Give'"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'TotalQTYToGive'"
                            v-bind:isReadOnly="true"
                            v-model="TotalQtyToGive"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="auto" sm="12">
                        <MdEdit
                            v-bind:Label="'Filled To Give'"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'FilledToGive'"
                            v-bind:isReadOnly="true"
                            v-model="FilledToGive"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="auto" sm="12" v-if="PharmacyOption.useOmnicellMARS">
                        <MdEdit
                            v-bind:Label="'QTY Received From Omnicell'"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'QTYReceivedFromOmnicell'"
                            v-bind:isReadOnly="true"
                            v-model="QTYReceivedFromOmnicell"
                        >
                        </MdEdit>
                    </b-col>
                </b-row>
                <b-row> </b-row>
                <MdTitle
                    v-bind:Text="'Info to Filled'"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                    v-if="this.OrderDetail.length > 0"
                />

                <div class="groupscroll">
                    <div
                        v-if="showEmptyRecordsStockInfo"
                        v-bind:style="emptyRecordsStyle"
                        role="alert"
                        aria-live="polite"
                    >
                        <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                    </div>
                    <div v-for="(item, index) in this.OrderDetail" :key="index">
                        <b-row class="groupingRow">
                            <b-col md="2" sm="12">
                                <MdEdit
                                    v-bind:Label="'QTY To Give'"
                                    v-bind:TypeProp="'number'"
                                    v-bind:Name="'QTYToGive_' + index"
                                    v-bind:Id="'QTYToGive_' + index"
                                    v-bind:isReadOnly="false"
                                    v-model.number="item.qtyToFill"
                                    @blur="
                                        blurQTYToGive(
                                            item.qtyToFill,
                                            item.qtyAvailable,
                                            'QTYToGive_' + index
                                        )
                                    "
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="1" sm="12">
                                <MdEdit
                                    v-bind:Label="'Lot. No'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'LotNo'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.lotNo"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="1" sm="12">
                                <MdEdit
                                    v-bind:Label="'Location'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'LocationFilled'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.location"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="2" sm="12">
                                <MdEdit
                                    v-bind:Label="'QTY Received'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'QTYReceived'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.quantity"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="1" sm="12">
                                <MdEdit
                                    v-bind:Label="'QTY Avail'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'QTYAvail'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.qtyAvailable"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="1" sm="12">
                                <MdEdit
                                    v-bind:Label="'Prev Used'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'PrevUsed'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.qtyPreviouslyUsed"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="2" sm="12">
                                <MdEdit
                                    v-bind:Label="'Exp Date'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'ExpDate'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.expirationDate"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col md="2" sm="12">
                                <MdEdit
                                    v-bind:Label="'Exp Info'"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'ExpInfo'"
                                    v-bind:isReadOnly="true"
                                    v-model="item.expirationInfo"
                                >
                                </MdEdit>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </form>
        </BaseModal>
        <!--<div class="space-actions"></div>
           <div class="page-actions" v-if="!OpenInModal">
               <MdButton
                  v-bind:Label="$t('Shared.Back')"
                  v-bind:Name="'btnpatientlist'"
                  v-bind:ClassProp="'secondary mx-2 btn-login'"
                  v-on:click="DiscardChanges"/>
            </div>-->

        <BaseModal
            v-if="DataBankVisible"
            ModalId="ModalDataBank"
            :key="'ModalDataBank'"
            :TitleWindow="
                FirstDataDrugName
                    ? $t('Shared.DrugInfo') + ` - ` + FirstDataDrugName
                    : $t('Shared.DrugInfo')
            "
            :width="'70%'"
            :height="'85vh'"
            :UseUpClass="true"
            :HideModalFun="DataBankOnCancel"
            @Close="DataBankOnCancel"
            :buttons="[{ text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }]"
        >
            <DataBankSearch
                :SearchCriteria.sync="SearchBank"
                :DrugCode="this.DrugCode"
                :PatientCode="this.PatientCode"
                :AdmissionRecordId="AdmRecordId"
                @UpdateDataDrugName="UpdateDataDrugName"
            >
            </DataBankSearch>
        </BaseModal>

        <BaseModal
          v-if="VisibleDrugInteraction"
          ModalId="ModalDrugInteraction"
          :key="'ModalDrugInteraction'"
          :TitleWindow="'Drug Interaction'"
          :width="'70%'"
          :height="'85vh'"
          :UseUpClass="true"
          :HideModalFun="DrugInteractionOnCancel"
          @Close="DrugInteractionOnCancel"
          :buttons="[
              { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
          ]">

          <DrugInteraction :PatientCode="this.PatientCode"></DrugInteraction>


      </BaseModal>



    </div>
</template>

<script>
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import MarsService from '@/services/mars.service';
import EmployeeService from '@/services/employee.service';
import GlobalService from '@/services/global.service';
import PharmacyOptionsService from '@/services/pharmacyoption.service';
import { EventBus } from '@/event-bus.js';
import ReasonService from '@/services/reason.service';
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import DrugOrdersInboxService from '@/services/drugordersinbox.service';
import OmniCellInBoundService from '@/services/omnicellinbounds.service';
import InventoryItemService from '@/services/inventoryitem.service';
import MedicationService from '@/services/medication.service';
//import navigationCache from "@/components/Cache/navigationCache"
import EnumService from '@/services/enum.service';
import DBFunctions from '@/common/DBFunctions.js';
import moment from 'moment';
import DrugInteraction from '@/components/MedEZComponents/DataBank/DrugInteraction';

let elemSaveBtn = '';
export default {
    name: 'MarsView',
    components:{DrugInteraction},
    props: {
        OpenInModal: Boolean,
        DFrom: String,
        DTo: String,
        PCode: String,
        PObj: Object
    },
    mixins: [ShowMessage, DBFunctions],
    data() {
        return {
            VisibleDrugInteraction:false,
            DataBankVisible: false,
            SearchBank: '',
            FirstDataDrugName: '',
            OptionsRightMenu: {
                visible: true,
                ItemsList: [],
                btnvisible: true,
                itemdisabled: false
            },
            RegistrationInfo: {},
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            PhotoObj: this.PObj ? this.PObj : {},
            PatientCode: this.PCode ? this.PCode : '',
            DateFrom: '',
            DateTo: '',
            isNRC: this.$store.state.companies.isNRC,
            DailyQTYUsed: null,
            DrugName: '',
            Availability: '',
            TotalQtyToGive: 0,
            FilledToGive: 0,
            QTYToGive: 0,
            LotNo: '',
            LocationFilled: '',
            QTYReceived: 0,
            QTYAvail: 0,
            PrevUsed: 0,
            ExpDate: '',
            ExpInfo: '',
            DrugCode: '',
            QtySet: 0,
            DailyQtySet: 0,
            MedRecordId: '',
            QTYFromOmnicell: 0,
            QTYReceivedFromOmnicell: null,
            OrderDetail: [],
            OrderDetailCopy: [],
            OmniCellInBound: [],
            aQTYFromOmnicell: 0,
            MinReorderLevel: null,
            OmniCellInBoundRecId: null,
            OpenStockByAuto: false,
            Mode: '',
            isUAE: this.$store.state.companies.isUAE,
            Location: { code: '', description: '' },
            MarsRecNo: null,
            LocationList: [],
            VisibleModalStockInfo: false,
            IsValidDateandTimeFrom: true,
            IsValidDateandTimeTo: true,
            isOpenCollapseClicked: false,
            btnIdClicked: '',
            pendingChanges: false,
            showSignPassword: false,
            dailyUse: 1,
            AdmRecordId: null,
            RecordId: null,
            RecNo: null,
            PharmacyOption: {},
            CollapseSelected: '',
            ReasonList: [],
            activeModal: false,
            outComeTitle: 'Assessments',
            outComeDescription: '',
            outComeCode: '',
            AssessmentModalId: 'MarsMedicationModalPainAssessmentList',
            PainAssessmentId: 'MarsMedicationModalPainAssessment',
            InsuranceId: 'MarsMedicationModalInsurance',
            PatientVitalId: 'MarsMedicationModalPatientVital',
            GenericId: 'MarsMedicationModalGeneric',
            DiagCodeId: 'MarsMedicationModalDiagCodes',
            AllergyId: 'MarsMedicationModalAllergy',
            ContactId: 'MarsMedicationModalContact',
            activeModalVitalSign: false,
            activateModalGeneric: false,
            activateModalAllergies: false,
            activateModalPainAssessmentList: false,
            activateModalHighAlertAssessmentNotes: false,
            activateModalInjectionAssessmentNotes: false,
            listCopyImages: [],
            From: null,
            To: null,
            // Johnny was here
            //images: [], // Stores images from the API

            images: [],

            MarsParam: {
                indexParent: null,
                indexAdministracion: null,
                indexAssessment: null
            },
            Obj1: {},
            Obj2: {},
            slide: 0,
            sliding: null,
            parentIndex: 0,
            childindex: 0,
            InsertStatus: false,
            DateTimeNow: null,
            DateNow: null,
            isTypePRN: false,
            isReadOnly: false,
            UsePrn: true,
            ViewReadOnly: false,
            TypeList: ['N', 'T', 'M'],
            MedList: [],
            MedListCopy: [],
            disableAddAllergies: false,
            Load: false,
            perPage: 10,
            countAlerts: 0,
            totalRows: 0,
            currentPage: 1,
            showEmptyRecordsStockInfo: false,
            showEmptyRecords: false,
            DateFromModal: this.DateFrom,
            DateToModal: this.DateTo,
            unitSys: 'U',
            parameter: {
                DateTimeFrom: null,
                DateTimeTo: null,
                PatientList: [],
                LevelList: [],
                BuildingList: [],
                RoomList: [],
                ProgramList: [],
                SearchCriteria: null,
                PageSize: 10,
                PageNumber: 1
            },
            perPageStyle: {
                width: 'auto'
            },
            options: [
                { value: 5, text: '5' },
                { value: 10, text: '10' },
                { value: 15, text: '15' }
            ],
            mode: { code: 'TIMED', name: 'TIMED' },
            ModeList: [
                { code: '', name: 'ALL' },
                { code: 'TIMED', name: 'TIMED' },
                { code: 'PRN', name: 'PRN' }
            ],
            StatusList: [
                { code: null, name: 'All' },
                { code: 'Given', name: 'Given' },
                { code: 'NoGiven', name: 'No Given' },
                { code: 'PendingToGive', name: 'Pending To Give' }
            ],
            Status: { code: 'PendingToGive', name: 'Pending To Give' },
            emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },
    methods: {
        getUrlDrugInfo(DrugCode) {
            MedicationService.getUrlDrugInfo(DrugCode)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        window.open(response.data.url, '_blank');
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        OpenDataBank() {
            this.SearchBank = this.DrugName;
            this.DataBankVisible = true;
        },

        OpenDrugInfo(item) {
            this.DrugCode = item.drugCode;
            this.DrugName = item.drugName;
            this.PatientCode = item.patientCode;
            this.AdmRecordId = item.admissionRecordId;

            if (!this.$store.state.UseFirstDataBank) {
                this.getUrlDrugInfo(this.DrugCode);
            } else {
                this.OpenDataBank();
            }
        },

        DataBankOnCancel() {
            this.DataBankVisible = false;
        },

        UpdateDataDrugName(name) {
            this.FirstDataDrugName = name;
        },

         DrugInteractionOnCancel(){
            this.VisibleDrugInteraction = false;
        },

        DiscardChanges() {
            this.$router.push({
                name: 'MarsClinical',
                params: { id: this.$route.params.id, recordid: this.$route.params.recordid }
            });
        },

        async GetPatientByCode() {
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        },

        PopulatePatientTitle() {
            const {
                dob,
                dateFrom,
                dateTo,
                age,
                programName,
                patientName,
                ageFormatted
            } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);

            if (this.$route.name.includes('MarsClinical')) {
                if (programName) this.PatientTitle.programName = programName;
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age === 0 ? '0' : age;
                if (ageFormatted)
                    this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }

            if (this.$route.name.includes('patient-')) {
                this.PatientTitle.programName = '';
                this.PatientTitle.dateFrom = '';
                this.PatientTitle.dateTo = '';
                this.PatientTitle.dob = this.patient.dob;
                this.PatientTitle.fullName = this.patient.firstname + ' ' + this.patient.lastname;
            }
        },

        async ChangeDropDownStockInfoLocation(item) {
            this.Location = item;
            await this.GetOrderHeader(
                this.MedRecordId,
                this.DrugCode,
                this.Location.code ? this.Location.code : ''
            );
            await this.getOrderDetail(
                this.MedRecordId,
                this.DrugCode,
                this.Location.code ? this.Location.code : '',
                this.QtySet,
                this.Mode,
                this.DailyQtySet,
                this.DailyQTYUsed
            );

            if (this.FilledToGive === 0) {
                this.showMessage(
                    this.$tc('Msg.Warning'),
                    'Item not available in the selected location. ' + this.DrugName,
                    'warning'
                );
                /*this.$bvModal.msgBoxConfirm("Item not available in the selected location. "+this.DrugName, {
                title: this.$tc('Shared.Confirm'),
                okTitle: this.$t('Shared.TitleOK'),
                cancelTitle: this.$t('Shared.BtnCancel'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning',
                id:'modal_warnMarsFilledFilledToGive'
            })*/
            }
        },

        UpdateFiledToGive(qtyToFill, qtyAvailable, Id) {
            let arr = this.OrderDetail;
            let total = 0;
            arr.forEach(function(item) {
                total += item.qtyToFill;
            });
            if (qtyToFill <= this.TotalQtyToGive && qtyToFill <= qtyAvailable) {
                this.FilledToGive = total;
            } else {
                document.getElementById(Id).focus();
            }
        },

        setFocus(Id) {
            document.getElementById(Id).focus();
        },

        blurQTYToGive(qtyToFill, qtyAvailable, Id) {
            if (qtyToFill > qtyAvailable) {
                this.setFocus(Id);
                this.showMessage(
                    this.$tc('Msg.Error'),
                    'Quantity to give cannot exceed available quantity',
                    'error'
                );
                return;
            }

            if (qtyToFill > this.TotalQtyToGive) {
                this.setFocus(Id);
                this.showMessage(
                    this.$tc('Msg.Error'),
                    'Quantity to give cannot exceed the total quantity to give',
                    'error'
                );
                return;
            }
            this.UpdateFiledToGive(qtyToFill, qtyAvailable, Id);
        },

        HideModalStockInfo() {
            this.VisibleModalStockInfo = false;
        },

        CloseStockInfo() {
            this.VisibleModalStockInfo = false;
            this.OrderDetail = this.OrderDetailCopy;
        },

        OKClickStockInfo(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.handleSubmit(this.parentIndex, this.childindex);
        },

        checkFormValidity() {
            let arr = this.OrderDetail;
            let count = 0;
            let result = true;
            arr.forEach(element => {
                count += element.qtyToFill;
            });

            if (count > this.TotalQtyToGive) {
                result = false;
            }

            return result;
        },

    IsSamePatientCode(arr){
      return arr.every(item => item.patientCode === arr[0].patientCode);
    },

    IsSameDrugCode(arr){
      return arr.every(item => item.drugCode === arr[0].drugCode);
    },

        OpenDrugInteraction(item){
            //this.PatientCode = this.selected.length > 0 && this.IsSamePatientCode(this.selected) ? this.selected[0].patientCode : null;
            this.PatientCode =  item.patientCode;
            this.VisibleDrugInteraction = true;
        },

        async GetMinReorderLevel() {
            this.MinReorderLevel = null;
            await InventoryItemService.get(this.DrugCode)
                .then(response => {
                    if (response.data) {
                        this.MinReorderLevel = response.data.minreorderlevel;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        SetGiveQTY(index, indexChild) {
            this.MedList = [];
            this.MedListCopy[index].marsAdministrations[indexChild].givenQTY = this.FilledToGive;
            this.MedList = [...this.MedListCopy];
        },

        ValidateAll(index, indexChild) {
            if (this.FilledToGive < this.TotalQtyToGive) {
                this.$bvModal
                    .msgBoxConfirm(
                        'Please note that you are filling ' +
                            this.FilledToGive +
                            ' which is less than the ' +
                            this.TotalQtyToGive +
                            ' quantity prescribed. Are you sure you want to continue?',
                        {
                            title: this.$tc('Shared.Confirm'),
                            okTitle: this.$t('Shared.TitleOK'),
                            cancelTitle: this.$t('Shared.BtnCancel'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning',
                            id: 'modal_warnMarsFilled'
                        }
                    )
                    .then(async value => {
                        if (value) {
                            await this.GetMinReorderLevel();
                            if (this.MinReorderLevel !== null && this.MinReorderLevel !== -1) {
                                if (this.Availability - this.FilledToGive <= this.MinReorderLevel) {
                                    // this.showMessage(this.$tc('Msg.Error'),"The quantity available for the drug "+this.DrugName+" is less than the minimum reorder level of "+this.MinReorderLevel,"error");
                                    this.$bvModal
                                        .msgBoxOk(
                                            'The quantity available for the drug ' +
                                                this.DrugName +
                                                ' is less than the minimum reorder level of ' +
                                                this.MinReorderLevel,
                                            {
                                                title: 'Info',
                                                okTitle: this.$t('Shared.TitleOK'),
                                                footerClass: 'p-2',
                                                titleClass: 'modal-title modal-type-warning',
                                                okVariant: 'primary'
                                            }
                                        )
                                        .then(async () => {
                                            await this.SetGiveQTY(index, indexChild);
                                            this.VisibleModalStockInfo = false;
                                            if (this.OpenStockByAuto) {
                                                this.SaveAutoByStockOK(this.MedList[index]);
                                            } else {
                                                this.GiveByStockInfoOk(
                                                    this.MedList[index],
                                                    this.MedList[index].marsAdministrations[
                                                        indexChild
                                                    ],
                                                    this.parentIndex,
                                                    this.childindex
                                                );
                                            }
                                        });
                                } else {
                                    this.SetGiveQTY(index, indexChild);
                                    this.VisibleModalStockInfo = false;
                                    if (this.OpenStockByAuto) {
                                        this.SaveAutoByStockOK(this.MedList[index]);
                                    } else {
                                        this.GiveByStockInfoOk(
                                            this.MedList[index],
                                            this.MedList[index].marsAdministrations[indexChild],
                                            this.parentIndex,
                                            this.childindex
                                        );
                                    }
                                }
                            } else {
                                this.SetGiveQTY(index, indexChild);
                                this.VisibleModalStockInfo = false;
                                if (this.OpenStockByAuto) {
                                    this.SaveAutoByStockOK(this.MedList[index]);
                                } else {
                                    this.GiveByStockInfoOk(
                                        this.MedList[index],
                                        this.MedList[index].marsAdministrations[indexChild],
                                        this.parentIndex,
                                        this.childindex
                                    );
                                }
                            }
                        }
                    });
            } else {
                this.SetGiveQTY(index, indexChild);
                this.VisibleModalStockInfo = false;
                if (this.OpenStockByAuto) {
                    this.SaveAutoByStockOK(this.MedList[index]);
                } else {
                    this.GiveByStockInfoOk(
                        this.MedList[index],
                        this.MedList[index].marsAdministrations[indexChild],
                        this.parentIndex,
                        this.childindex
                    );
                }
            }
        },

        handleSubmit(index, indexchild) {
            if (!this.checkFormValidity()) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    'The ' +
                        this.FilledToGive +
                        ' quantity filled to give exceeds the total quantity prescribed of ' +
                        this.TotalQtyToGive,
                    'error'
                );
                return;
            } else {
                this.ValidateAll(index, indexchild);
                // this.VisibleModalStockInfo = false;
            }
        },

        async GetQTYTakenFromOmnicell(RecordId) {
            this.OmniCellInBound = [];
            await OmniCellInBoundService.getAllOmniCellInBounds(RecordId)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.OmniCellInBound = response.data;
                        this.aQTYFromOmnicell = response.data[0].rxQty;
                        this.MarsRecNo = response.data[0].marsRecNo;
                        this.OmniCellInBoundRecId = response.data[0].recId;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async GetOrderHeader(RecordId, DrugCode, location) {
            await DrugOrdersInboxService.getOrderHeaderMars(RecordId, DrugCode, location)
                .then(response => {
                    if (response.data) {
                        this.DrugName = response.data.drugName;
                        this.Availability = response.data.qtyAvailableUOM;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getOrderDetail(
            RecordId,
            DrugCode,
            location,
            QtySet,
            Mode,
            dailyQTYSet,
            dailyQTYUsed
        ) {
            let GivenQTY = Mode === 'PRN' ? dailyQTYSet - dailyQTYUsed : QtySet;

            if (this.PharmacyOption.useOmnicellMARS) {
                if (this.aQTYFromOmnicell < GivenQTY) {
                    GivenQTY = this.aQTYFromOmnicell;
                }
                this.QTYReceivedFromOmnicell = this.aQTYFromOmnicell;
            }

            await DrugOrdersInboxService.getOrderDetailsMars(RecordId, DrugCode, location, GivenQTY)
                .then(response => {
                    if (response.data) {
                        this.OrderDetail = response.data;
                        this.showEmptyRecordsStockInfo =
                            this.OrderDetail.length === 0 ? true : false;
                        let total = 0;
                        this.OrderDetail.forEach(function(item) {
                            total += item.qtyToFill;
                            if (item.expirationDate)
                                item.expirationDate = Utils.formatterDateToString(
                                    item.expirationDate
                                );
                        });
                        this.FilledToGive = total;

                        this.OrderDetailCopy = JSON.parse(JSON.stringify(this.OrderDetail));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        //-----------------------------------------------------------------------------------------------------------------------------------
        //---------------------------------------------------------------------------------------------
        async StockInfo(
            RecordId,
            DrugCode,
            QtySet,
            Mode,
            dailyQTYSet,
            dailyQTYUsed,
            index,
            indexchild,
            itemchild
        ) {
            this.parentIndex = index;
            this.childindex = indexchild;

            await this.getDateTime(itemchild);
            this.MedList = [];
            this.MedListCopy[index].marsAdministrations[indexchild].givenTime = this.DateTimeNow;
            this.MedList = [...this.MedListCopy];

            if (this.PharmacyOption.useOmnicellMARS) {
                await this.GetQTYTakenFromOmnicell(RecordId);
                if (this.OmniCellInBound.length > 0) {
                    this.ShowStockInfoScreen(
                        RecordId,
                        DrugCode,
                        QtySet,
                        Mode,
                        dailyQTYSet,
                        dailyQTYUsed
                    );
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('modalMarsMed.OmnicellMARSError'),
                        'error'
                    );
                }
            } else {
                this.ShowStockInfoScreen(
                    RecordId,
                    DrugCode,
                    QtySet,
                    Mode,
                    dailyQTYSet,
                    dailyQTYUsed
                );
            }
        },

        async SaveAutoByStockOK(item) {
            await this.getDateTime();
            this.Obj1 = item;
            this.Obj2 = item.marsAdministrations[item.marsAdministrations.length - 1];
            if (this.PharmacyOption.byPassMarsSignature) {
                if (item.mode === 'PRN') {
                    item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                    item.marsAdministrations[
                        item.marsAdministrations.length - 1
                    ].givenTime = this.DateTimeNow;
                    item.marsAdministrations[
                        item.marsAdministrations.length - 1
                    ].givenQTY = this.Obj2.givenQTY;
                    await this.InsertAdministration(
                        item,
                        item.marsAdministrations[item.marsAdministrations.length - 1],
                        true,
                        this.CollapseSelected
                    );
                    if (this.InsertStatus) {
                        this.AddAdm(item);
                        this.InsertStatus = false;
                    }
                } else {
                    item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                    item.marsAdministrations[
                        item.marsAdministrations.length - 1
                    ].givenTime = this.DateTimeNow;
                    item.marsAdministrations[
                        item.marsAdministrations.length - 1
                    ].givenQTY = this.Obj2.givenQTY;
                    await this.UpdateAdministration(
                        item,
                        item.marsAdministrations[0],
                        this.CollapseSelected
                    );
                }
            } else {
                if (this.$store.state.alreadyWrotePassword) {
                    if (item.mode === 'PRN') {
                        item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenTime = this.DateTimeNow;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenQTY = this.Obj2.givenQTY;
                        await this.InsertAdministration(
                            item,
                            item.marsAdministrations[item.marsAdministrations.length - 1],
                            true,
                            this.CollapseSelected
                        );
                        if (this.InsertStatus) {
                            this.AddAdm(item);
                            this.InsertStatus = false;
                        }
                    } else {
                        item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenTime = this.DateTimeNow;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenQTY = this.Obj2.givenQTY;
                        await this.UpdateAdministration(
                            item,
                            item.marsAdministrations[0],
                            this.CollapseSelected
                        );
                    }
                } else {
                    this.showSignPassword = true;
                }
            }
        },

        async SaveAuto(e, item, idCollapse, index) {
            this.CollapseSelected = idCollapse;

            if (!this.PharmacyOption.showMARSStockInfo) {
                e.stopPropagation();
                await this.getDateTime();
                this.Obj1 = item;
                this.Obj2 = item.marsAdministrations[item.marsAdministrations.length - 1];
                if (this.PharmacyOption.byPassMarsSignature) {
                    if (item.mode === 'PRN') {
                        e.stopPropagation();
                        item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenTime = this.DateTimeNow;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenQTY = this.Obj2.givenQTY;
                        await this.InsertAdministration(
                            item,
                            item.marsAdministrations[item.marsAdministrations.length - 1],
                            true,
                            idCollapse
                        );
                        if (this.InsertStatus) {
                            this.AddAdm(item);
                            this.InsertStatus = false;
                        }
                    } else {
                        e.stopPropagation();
                        item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenTime = this.DateTimeNow;
                        item.marsAdministrations[
                            item.marsAdministrations.length - 1
                        ].givenQTY = this.Obj2.givenQTY;
                        await this.UpdateAdministration(
                            item,
                            item.marsAdministrations[0],
                            idCollapse
                        );
                    }
                } else {
                    if (this.$store.state.alreadyWrotePassword) {
                        if (item.mode === 'PRN') {
                            e.stopPropagation();
                            item.marsAdministrations[
                                item.marsAdministrations.length - 1
                            ].given = true;
                            item.marsAdministrations[
                                item.marsAdministrations.length - 1
                            ].givenTime = this.DateTimeNow;
                            item.marsAdministrations[
                                item.marsAdministrations.length - 1
                            ].givenQTY = this.Obj2.givenQTY;
                            await this.InsertAdministration(
                                item,
                                item.marsAdministrations[item.marsAdministrations.length - 1],
                                true,
                                idCollapse
                            );
                            if (this.InsertStatus) {
                                this.AddAdm(item);
                                this.InsertStatus = false;
                            }
                        } else {
                            e.stopPropagation();
                            item.marsAdministrations[
                                item.marsAdministrations.length - 1
                            ].given = true;
                            item.marsAdministrations[
                                item.marsAdministrations.length - 1
                            ].givenTime = this.DateTimeNow;
                            item.marsAdministrations[
                                item.marsAdministrations.length - 1
                            ].givenQTY = this.Obj2.givenQTY;
                            await this.UpdateAdministration(
                                item,
                                item.marsAdministrations[0],
                                idCollapse
                            );
                        }
                    } else {
                        e.stopPropagation();
                        this.showSignPassword = true;
                    }
                }
            } else {
                let RecordId = item.recordId;
                let DrugCode = item.drugCode;
                let QtySet = item.qtySet;
                let Mode = item.mode;
                let dailyQTYSet = item.dailyQTYSet;
                let dailyQTYUsed = item.dailyQTYUsed;
                let Index = index;
                let IndexChild = item.marsAdministrations.length - 1;
                let itemchild = item.marsAdministrations[item.marsAdministrations.length - 1];
                this.OpenStockByAuto = true;

                this.StockInfo(
                    RecordId,
                    DrugCode,
                    QtySet,
                    Mode,
                    dailyQTYSet,
                    dailyQTYUsed,
                    Index,
                    IndexChild,
                    itemchild
                );
            }
        },

        async ShowStockInfoScreen(RecordId, DrugCode, QtySet, Mode, dailyQTYSet, dailyQTYUsed) {
            this.TotalQtyToGive = QtySet;
            this.MedRecordId = RecordId;
            this.DrugCode = DrugCode;
            this.QtySet = QtySet;
            this.DailyQtySet = dailyQTYSet;
            this.Mode = Mode;
            this.DailyQTYUsed = dailyQTYUsed;
            await this.getPharmacyLocations();
            await this.GetOrderHeader(
                RecordId,
                DrugCode,
                this.Location.code ? this.Location.code : ''
            );
            await this.getOrderDetail(
                RecordId,
                DrugCode,
                this.Location.code ? this.Location.code : '',
                QtySet,
                Mode,
                dailyQTYSet,
                dailyQTYUsed
            );
            this.VisibleModalStockInfo = true;
        },

        PrepareFill(arr) {
            let arrtest = JSON.parse(JSON.stringify(arr));
            arrtest.forEach(element => {
                element.expirationDate = Utils.formatterToISO(
                    element.expirationDate,
                    Utils.getShortDateFormat()
                );
            });
            return arrtest;
        },

        async ProcessHeaderAndDetailOrder(given) {
            if (this.PharmacyOption.showMARSStockInfo && given) {
                let data = {
                    IsMars: true,
                    OmniCellInBoundRecId: this.OmniCellInBoundRecId,
                    MarsRecNo: this.MarsRecNo,
                    RecordID: this.MedRecordId,
                    OrderDetails: this.PrepareFill(this.OrderDetail)
                };
                await DrugOrdersInboxService.FillOrder(data)
                    .then(response => {
                        if (response.status == '200') {
                            console.log(response.data);
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        GetNeedAssessmentLabel(item, itemchild) {
            if (this.VerifyAllAssessment(item, itemchild.assessmentDetails)) {
                return this.$t('modalMarsMed.AssessmentCompleted');
            }

            return this.$t('modalMarsMed.Assessment');
        },

        GetItemChildPrefix(item, itemchild) {
            if (itemchild.recNo) {
                return `RC${itemchild.recNo}`;
            }

            const index = this.MedList.indexOf(item);
            const childIndex = item.marsAdministrations.indexOf(itemchild);
            return `II${index}_CI${childIndex}`;
        },

        ContainImageUrl(Code) {
            for (var i = 0; i < this.listCopyImages.length; i++) {
                if (this.listCopyImages[i].Code === Code) {
                    return true;
                }
            }
            return false;
        },

        getListImageinCopy(Code) {
            for (var i = 0; i < this.listCopyImages.length; i++) {
                if (this.listCopyImages[i].Code === Code) {
                    return this.listCopyImages[i].images;
                }
            }
            return [];
        },

        async ImageDrugName(item) {
            this.images = [];

            if (!this.ContainImageUrl(item.drugCode)) {
                this.Load = true;
                await MarsService.getImageByDrug(item.drugCode)
                    .then(response => {
                        if (response.status == '200') {
                            this.images = response.data.images;
                            if (!this.ContainImageUrl(item.drugCode)) {
                                this.listCopyImages.push({
                                    Code: item.drugCode,
                                    images: this.images
                                });
                            }
                        }
                        this.Load = false;
                    })
                    .catch(error => {
                        this.Load = false;
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, 'error');
                        }
                    });
            } else {
                this.images = this.getListImageinCopy(item.drugCode);
            }
        },

        onSlideStart() {
            this.sliding = true;
        },
        onSlideEnd() {
            this.sliding = false;
        },

        async getPharmacyLocations() {
            const parameter = {
                PageSize: null,
                PageNumber: null
            };
            this.LocationList = [];
            await ePharmacyLocationsService
                .getAll(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        const data = response.data;
                        data.forEach(element => {
                            this.LocationList.push({
                                code: element.code.trim(),
                                description: element.name
                            });
                        });

                        if (this.LocationList.length > 0) {
                            this.Location.code = this.LocationList[0].code;
                            this.Location.description = this.LocationList[0].description;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            this.IsValidDateandTimeFrom = this.DateFromModal ? true : false;
            this.IsValidDateandTimeTo = this.DateToModal ? true : false;
            return this.IsValidDateandTimeFrom && this.IsValidDateandTimeTo;
        },

        DeleteAdm(item, itemchild, indexchild) {
            if (itemchild.isNewAdm && item.marsAdministrations.length > 1) {
                item.marsAdministrations.splice(indexchild, 1);
                this.MedList = [];
                this.MedList = [...this.MedListCopy];
            }
        },

        IsHover(over, index) {
            if (over) {
                this.MedList = [];
                this.MedListCopy[index].isHovered = true;
                this.MedList = [...this.MedListCopy];
            } else {
                this.MedList = [];
                this.MedListCopy[index].isHovered = false;
                this.MedList = [...this.MedListCopy];
            }
        },

        async GiveByStockInfoOk(item, itemchild, index, indexChild) {
            if (item.needAssessment) {
                if (this.VerifyAllAssessment(item, itemchild.assessmentDetails)) {
                    await this.getDateTime();
                    this.MedList = [];
                    this.MedListCopy[index].marsAdministrations[indexChild].given = true;
                    this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].givenTime = this.DateTimeNow;
                    this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
                    this.MedListCopy[index].marsAdministrations[indexChild].givenQTY =
                        item.mode !== 'PRN'
                            ? item.qtySet
                            : this.PharmacyOption.showMARSStockInfo
                            ? this.FilledToGive
                            : null;
                    this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
                    this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].administrationNotesUndo = this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].administrationNotes;
                    this.MedList = [...this.MedListCopy];
                    this.pendingChanges = true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('modalMarsMed.NeedAssessment'),
                        'error'
                    );
                }
            } else {
                await this.getDateTime();
                this.MedList = [];
                this.MedListCopy[index].marsAdministrations[indexChild].given = true;
                this.MedListCopy[index].marsAdministrations[
                    indexChild
                ].givenTime = this.DateTimeNow;
                this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
                this.MedListCopy[index].marsAdministrations[indexChild].givenQTY =
                    item.mode !== 'PRN'
                        ? item.qtySet
                        : this.PharmacyOption.showMARSStockInfo
                        ? this.FilledToGive
                        : null;
                this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
                this.MedListCopy[index].marsAdministrations[
                    indexChild
                ].administrationNotesUndo = this.MedListCopy[index].marsAdministrations[
                    indexChild
                ].administrationNotes;
                this.MedList = [...this.MedListCopy];
                this.pendingChanges = true;
            }
        },

        async Give(item, itemchild, index, indexChild) {
            itemchild.disabledGiven = true;
            itemchild.DisaBledBtnAdm = false;

            if (!this.PharmacyOption.showMARSStockInfo) {
                if (item.needAssessment) {
                    if (this.VerifyAllAssessment(item, itemchild.assessmentDetails)) {
                        await this.getDateTime();
                        this.MedList = [];
                        this.MedListCopy[index].marsAdministrations[indexChild].given = true;
                        this.MedListCopy[index].marsAdministrations[
                            indexChild
                        ].givenTime = this.DateTimeNow;
                        this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
                        this.MedListCopy[index].marsAdministrations[indexChild].givenQTY =
                            item.mode !== 'PRN'
                                ? item.qtySet
                                : this.PharmacyOption.showMARSStockInfo
                                ? this.FilledToGive
                                : null;
                        this.MedListCopy[index].marsAdministrations[
                            indexChild
                        ].reasonCodeModel = null;
                        this.MedListCopy[index].marsAdministrations[
                            indexChild
                        ].administrationNotesUndo = this.MedListCopy[index].marsAdministrations[
                            indexChild
                        ].administrationNotes;
                        this.MedList = [...this.MedListCopy];
                        this.pendingChanges = true;
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('modalMarsMed.NeedAssessment'),
                            'error'
                        );
                    }
                } else {
                    await this.getDateTime();
                    this.MedList = [];
                    this.MedListCopy[index].marsAdministrations[indexChild].given = true;
                    this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].givenTime = this.DateTimeNow;
                    this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
                    this.MedListCopy[index].marsAdministrations[indexChild].givenQTY =
                        item.mode !== 'PRN'
                            ? item.qtySet
                            : this.PharmacyOption.showMARSStockInfo
                            ? this.FilledToGive
                            : null;
                    this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
                    this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].administrationNotesUndo = this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].administrationNotes;
                    this.MedList = [...this.MedListCopy];
                    this.pendingChanges = true;
                }
            } else {
                let RecordId = item.recordId;
                let DrugCode = item.drugCode;
                let QtySet = item.qtySet;
                let Mode = item.mode;
                let dailyQTYSet = item.dailyQTYSet;
                let dailyQTYUsed = item.dailyQTYUsed;
                let Index = index;
                let IndexChild = indexChild;
                let itemchild = itemchild;
                this.OpenStockByAuto = false;
                this.parentIndex = Index;
                this.childindex = IndexChild;

                this.StockInfo(
                    RecordId,
                    DrugCode,
                    QtySet,
                    Mode,
                    dailyQTYSet,
                    dailyQTYUsed,
                    Index,
                    IndexChild,
                    itemchild
                );
            }
        },

        async NoGive(item, itemchild, index, indexChild) {
            itemchild.disabledNoGiven = true;
            itemchild.DisaBledBtnAdm = false;
            await this.getDateTime(itemchild);
            this.MedList = [];
            this.MedListCopy[index].marsAdministrations[indexChild].given = false;
            this.MedListCopy[index].marsAdministrations[indexChild].givenTime = this.DateTimeNow;
            this.MedListCopy[index].marsAdministrations[indexChild].givenQTY = null;
            this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
            this.MedListCopy[index].marsAdministrations[
                indexChild
            ].administrationNotesUndo = this.MedListCopy[index].marsAdministrations[
                indexChild
            ].administrationNotes;
            this.MedListCopy[index].marsAdministrations[indexChild].administrationNotes = '';
            this.MedList = [...this.MedListCopy];
            this.pendingChanges = true;
        },

        GiveUndo(item, itemchild, index, indexChild) {
            itemchild.givenTimeInvalidFeedbackMessage = '';
            itemchild.disabledNoGiven = false;
            itemchild.DisaBledBtnAdm = false;
            itemchild.givenQTY = null;
            this.MedList = [];
            this.MedListCopy[index].marsAdministrations[indexChild].given = null;
            this.MedListCopy[index].marsAdministrations[indexChild].givenTime = null;
            this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
            this.MedListCopy[index].marsAdministrations[indexChild].reason = { code: '', name: '' };
            this.MedListCopy[index].marsAdministrations[indexChild].givenQTY = null;
            this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
            this.MedListCopy[index].marsAdministrations[
                indexChild
            ].administrationNotes = this.MedListCopy[index].marsAdministrations[
                indexChild
            ].administrationNotesUndo;
            this.MedList = [...this.MedListCopy];
            this.pendingChanges = true;
            EventBus.$emit('OnResetModelSelect');
        },

        NoGiveUndo(item, itemchild, index, indexChild) {
            itemchild.givenTimeInvalidFeedbackMessage = '';
            itemchild.disabledGiven = false;
            itemchild.DisaBledBtnAdm = false;
            itemchild.givenQTY = null;
            if (item.needAssessment) {
                if (this.VerifyAllAssessment(item, itemchild.assessmentDetails)) {
                    this.MedList = [];
                    this.MedListCopy[index].marsAdministrations[indexChild].given = null;
                    this.MedListCopy[index].marsAdministrations[indexChild].givenTime = null;
                    this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
                    this.MedListCopy[index].marsAdministrations[indexChild].givenQTY = null;
                    this.MedListCopy[index].marsAdministrations[indexChild].reason = {
                        code: '',
                        name: ''
                    };
                    this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
                    this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].administrationNotes = this.MedListCopy[index].marsAdministrations[
                        indexChild
                    ].administrationNotesUndo;
                    this.MedList = [...this.MedListCopy];
                    this.pendingChanges = true;
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('modalMarsMed.NeedAssessment'),
                        'error'
                    );
                }
            } else {
                this.MedList = [];
                this.MedListCopy[index].marsAdministrations[indexChild].given = null;
                this.MedListCopy[index].marsAdministrations[indexChild].givenTime = null;
                this.MedListCopy[index].marsAdministrations[indexChild].reasonCode = null;
                this.MedListCopy[index].marsAdministrations[indexChild].givenQTY = null;
                this.MedListCopy[index].marsAdministrations[indexChild].reason = {
                    code: '',
                    name: ''
                };
                this.MedListCopy[index].marsAdministrations[indexChild].reasonCodeModel = null;
                this.MedListCopy[index].marsAdministrations[
                    indexChild
                ].administrationNotes = this.MedListCopy[index].marsAdministrations[
                    indexChild
                ].administrationNotesUndo;
                this.MedList = [...this.MedListCopy];
                this.pendingChanges = true;
            }

            EventBus.$emit('OnResetModelSelect');
        },

        getListing() {
            this.GetMedications();
        },

        ChangeDropDownStatus(item) {
            this.Status.code = item.code;
            this.Status.name = item.name;
            this.GetMedications();
        },

        ChangeDropDownMode(item) {
            this.mode = item ? item : { code: '', name: 'ALL' };
            // this.Status = this.mode.code === 'PRN' ? {code:null,name:"All"} : {code:"PendingToGive",name:"Pending To Give"};
            if (this.mode.code === 'PRN') {
                this.Status.code = null;
                this.Status.name = 'All';
                EventBus.$emit('ChangedDrop', { model: this.Status, Tag: 'MedicationModalStatus' });
                this.isTypePRN = true;
            } else {
                this.isTypePRN = false;
            }
            this.GetMedications();
        },

        maximumQuantityPRNInvalid(item) {
            if (item.mode == 'PRN') {
                const givenQTY = item.marsAdministrations.reduce(
                    (sum, { given, givenQTY }) =>
                        given && givenQTY ? parseInt(givenQTY, 10) + sum : sum,
                    0
                );
                return givenQTY > item.dailyQTYSet;
            }

            return false;
        },

        CanAddNewPRN(item) {
            if (item.readOnly === true) return false;

            if (item.dailyQTYSet) {
                if (
                    item.marsAdministrations.some(
                        it =>
                            it.given == null ||
                            it.given == undefined ||
                            (it.given === true &&
                                (it.givenQTY == null ||
                                    it.givenQTY == undefined ||
                                    parseInt(it.givenQTY, 10) == 0))
                    )
                ) {
                    return false;
                }

                const givenQTY = item.marsAdministrations.reduce(
                    (sum, { given, givenQTY }) =>
                        given && givenQTY ? parseInt(givenQTY, 10) + sum : sum,
                    0
                );
                return givenQTY < item.dailyQTYSet;
            }

            return false;
        },

        AddAdm(item) {
            item.marsAdministrations.unshift({
                isNewAdm: true,
                administrationNotes: '',
                administrationStatus: '',
                administrationStatusTranslated: '',
                expiredAdministration: false,
                given: null,
                givenDate: item.adminDate,
                givenQTY: null,
                assessmentDetails: item.assessmentTypes,
                givenTime: null,
                marsRecNo: null,
                metAssessment: false,
                reasonCode: null,
                reasonDescription: null,
                reviewedByName: '',
                reviewedOn: null,
                signed: false,
                reason: { code: '', name: '' },
                reasonCodeModel: null,
                lastGiven: null,
                givenTimeInvalidFeedbackMessage: ''
            });
        },

        PopulateUndoAdm() {
            for (var i = 0; i < this.MedList.length; i++) {
                let arr = this.MedList[i].marsAdministrations;
                let total = 0;
                arr.forEach(function(element) {
                    element.DisaBledBtnAdm = true;
                    element.disabledGiven = false;
                    element.givenTimeInvalidFeedbackMessage = '';
                    element.administrationNotes =
                        element.administrationNotes === null ? '' : element.administrationNotes;
                    //  element.expiredAdministration = true;
                    element.disabledNoGiven = false;
                    element.givenTime = element.givenTime
                        ? Utils.formatterTimeToString(
                              element.givenTime
                          ) /*Utils.formatterDateTimeToString(element.givenTime)*/
                        : null;
                    element.reviewedOn = element.reviewedOn
                        ? Utils.formatterDateTimeToString(element.reviewedOn)
                        : null;
                    element.reasonCodeModel = this.ReasonList.find(
                        x => x.code == element.reasonCode
                    );
                    element.reason = { code: element.reasonCode, name: element.reasonDescription };
                    element.lastGiven = element.given;
                    let quantity = element.givenQTY === null ? 0 : element.givenQTY;
                    total += quantity;
                }, this);

                this.MedList[i].quantityDailyAdm = total;
            }
            this.MedListCopy = [...this.MedList];
        },

        HaveOneGiven(index) {
            let count = 0;
            let arr = this.MedList[index].marsAdministrations;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].lastGiven !== null && arr[i].lastGiven) {
                    count++;
                }
            }
            return count > 0;
        },

        HaveOneNoGiven(index) {
            let count = 0;
            let arr = this.MedList[index].marsAdministrations;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].lastGiven !== null && !arr[i].lastGiven) {
                    count++;
                }
            }
            return count > 0;
        },

        GivenNeutro(index) {
            let count = 0;
            let arr = this.MedList[index].marsAdministrations;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].lastGiven === null) {
                    count++;
                }
            }
            return count === arr.length;
        },

        DoAssess(/*item,itemchild,assessmentItem,*/ index, indexChild, assessmentIndex) {
            this.MedList = [];
            this.MedListCopy[index].marsAdministrations[indexChild].assessmentDetails[
                assessmentIndex
            ].metAssessment = true;
            this.MedList = [...this.MedListCopy];
        },

        onCodeConditionOk(result) {
            let info = result.info;
            if (info !== null || info !== '') {
                let admin = result.MarsParam;
                this.MedList = [];
                this.MedListCopy[admin.indexParent].marsAdministrations[
                    admin.indexAdministracion
                ].administrationNotes += info + '\n';
                this.MedList = [...this.MedListCopy];

                this.DoAssess(
                    /*item,itemchild,assessmentItem,*/ admin.indexParent,
                    admin.indexAdministracion,
                    admin.indexAssessment
                );
            }

            this.deActivateModal();
        },

        onCodeConditionOkEmpty() {
            this.deActivateModal();
        },

        SearchMed() {
            this.GetMedications();
        },

        OnChangeGoals() {},

        VerifyAllAssessment(item, arr) {
            let count = 0;
            if (item.needAssessment) {
                arr.forEach(function(element) {
                    if (element.metAssessment) {
                        count++;
                    }
                });
                return count === arr.length;
            }
            return true;
        },

        showModalOutCome(assessmentItem, item, itemchild, index, indexchild, assessmentIndex) {
            this.MarsParam.indexParent = index;
            this.MarsParam.indexAdministracion = indexchild;
            this.MarsParam.indexAssessment = assessmentIndex;
            if (assessmentItem.templateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES') {
                this.outComeCode = assessmentItem.testCode;
                this.RecordId = item.recordId;
                this.activateModalPainAssessmentList = true;
            } else if (assessmentItem.templateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES') {
                this.outComeCode = assessmentItem.testCode;
                this.activeModalVitalSign = true;
            } else if (assessmentItem.templateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES') {
                this.outComeCode = assessmentItem.testCode;
                this.activateModalGeneric = true;
            } else if (assessmentItem.templateCode.toUpperCase() === 'TFRMALLERGIESEHR') {
                this.outComeCode = assessmentItem.testCode;
                this.activateModalAllergies = true;
            } else if (
                assessmentItem.templateCode.toUpperCase() === 'TFRMMDHIGHALERTASSESSMENTNOTES'
            ) {
                this.outComeCode = assessmentItem.testCode;
                this.RecordId = item.recordId;
                this.RecNo = item.recNo;
                this.activateModalHighAlertAssessmentNotes = true;
            } else if (
                assessmentItem.templateCode.toUpperCase() === 'TFRMMDINJECTIONASSESSMENTNOTES'
            ) {
                this.outComeCode = assessmentItem.testCode;
                this.RecordId = item.recordId;
                this.RecNo = item.recNo;
                this.activateModalInjectionAssessmentNotes = true;
            }
        },

        deActivateModal(/*item*/) {
            this.activeModalVitalSign = false;
            this.activateModalGeneric = false;
            this.activateModalAllergies = false;
            this.activateModalPainAssessmentList = false;
            this.activateModalHighAlertAssessmentNotes = false;
            this.activateModalInjectionAssessmentNotes = false;
        },

        ChangeDropDownReason(value, itemchild) {
            itemchild.reason.code = value ? value.code : null;
            itemchild.reason.name = value ? value.name : null;
            itemchild.reasonCode = value ? value.code : null;
            itemchild.reasonCodeModel = value;
            setTimeout(() => {
                itemchild.DisaBledBtnAdm = false;
            }, 10);
        },

        onChange(page) {
            this.currentPage = page;
            this.GetMedications();
        },

        getStatus(mode, index) {
            let status = '';
            if (mode === 'PRN') {
                status = '4_NO_PEND_ADM';
            } else {
                status = this.MedList[index].marsAdministrations[0].administrationStatus;
            }
            return status;
        },

        HasMoreThanOneAlert(index) {
            let count = 0;
            if (this.MedList[index].isHighAlert) {
                count++;
            }
            if (this.MedList[index].isLookAlikeSoundAlike) {
                count++;
            }
            if (this.MedList[index].allergicToDrug) {
                count++;
            }
            return count > 1;
        },

        getTitle(mode, index) {
            let statusTranslated = '';
            if (mode === 'PRN') {
                statusTranslated = this.$t('modalMarsMed.NoPendAdm');
            } else {
                statusTranslated = this.MedList[index].marsAdministrations[0]
                    .administrationStatusTranslated;
            }
            return statusTranslated;
        },

        perPageChange(value) {
            this.perPage = value;
            this.currentPage = 1;
            this.GetMedications();
        },

        async getDateTime() {
            await GlobalService.getDateTime()
                .then(response => {
                    if (response.data) {
                        this.DateTimeNow = Utils.formatterTimeToString(response.data); //Utils.formatterDateTimeToString(response.data);
                        this.DateNow = Utils.formatterDateToString(response.data);
                        this.From = Utils.formatterToISO2(
                            moment(response.data)
                                .subtract(1, 'hours')
                                .subtract(moment(response.data).minute(), 'minutes')
                        );
                        this.To = Utils.formatterToISO2(
                            moment(response.data)
                                .add(1, 'hours')
                                .subtract(moment(response.data).minute(), 'minutes')
                        );
                        // this.From = Utils.formatterToISO2(moment(response.data).subtract(1, 'hours').subtract(moment(response.data).minute(), 'minutes'));
                        //this.To = Utils.formatterToISO2(moment(response.data).add(1, 'hours').subtract(moment(response.data).minute(), 'minutes'));
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getReason() {
            ReasonService.getReasonMars()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.ReasonList = response.data;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.RetrieveInformation'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async EmployeeCanChange() {
            //  this.Load = true;
            var parameter = {
                TypeList: this.TypeList,
                Code: this.$store.state.employeeCode,
                Active: true
            };
            await EmployeeService.EmployeeCanChangesinView(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.ViewReadOnly = response.data.length === 0 ? true : false;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        getTestCodesCompleted(item, itemchild) {
            let result = [];
            if (item.needAssessment) {
                let arr = itemchild.assessmentDetails;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].metAssessment) {
                        result.push(arr[i].testCode);
                    }
                }
                return result;
            }

            return result;
        },

        validateItemChild(item, itemchild) {
            let reasonCodeModelValid = true;
            let givenTimeValid = true;

            if (
                itemchild.given === false &&
                (itemchild.reasonCode === null || itemchild.reasonCode === '')
            ) {
                reasonCodeModelValid = false;
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('modalMarsMed.ReasonNoSelected'),
                    'error'
                );
            }

            let givenTimeInvalidFeedbackMessage = '';
            if (itemchild.givenTime === null || itemchild.givenTime === '') {
                givenTimeValid = false;
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('modalMarsMed.GivenTimeError'),
                    'error'
                );
                givenTimeInvalidFeedbackMessage = this.$t('modalMarsMed.GivenTimeError');
            } else if (!Utils.isValidTime(itemchild.givenTime)) {
                givenTimeValid = false;
                this.showMessage(this.$tc('Msg.Error'), this.$t('Shared.ITime'), 'error');
                givenTimeInvalidFeedbackMessage = this.$t('Shared.ITime');
            } else if (
                itemchild.given &&
                Utils.toMidnight(item.adminDate, Utils.getDateTimeFormat()) >
                    Utils.toMidnight(this.DateNow, Utils.getShortDateFormat())
            ) {
                givenTimeValid = false;
                const adminDate = Utils.formatterDateToString(
                    Utils.toMidnight(item.adminDate, Utils.getDateTimeFormat())
                );
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('modalMarsMed.InvalidLaterDate', { date: adminDate }),
                    'error'
                );
                givenTimeInvalidFeedbackMessage = this.$t('modalMarsMed.InvalidLaterDate', {
                    date: adminDate
                });
            }

            itemchild.givenTimeInvalidFeedbackMessage = givenTimeInvalidFeedbackMessage;
            setTimeout(() => {
                this.$refs[
                    `reasonCodeModel_${this.GetItemChildPrefix(item, itemchild)}`
                ][0].setValid(reasonCodeModelValid);
                this.$refs[`givenTime_${this.GetItemChildPrefix(item, itemchild)}`][0].setValid(
                    givenTimeValid
                );
            }, 100);

            return givenTimeValid && reasonCodeModelValid;
        },

        UpdateAdministration(item, itemchild, idCollapse) {
            if (!this.validateItemChild(item, itemchild)) {
                return;
            }

            //let gtime = itemchild.givenTime;
            let gtime = Utils.CombineDateAndTime(
                Utils.toDate(item.adminDate, Utils.getDateTimeFormat()),
                Utils.toDate(itemchild.givenTime, 'HH:mm')
            ); //itemchild.givenTime ? Utils.formatterToISO(itemchild.givenTime, Utils.getDateTimeFormat()): null ;
            itemchild.givenQTY = itemchild.given
                ? itemchild.givenQTY
                    ? itemchild.givenQTY
                    : item.qtySet
                : null;
            let param = {
                RecordId: item.recordId,
                Given: itemchild.given,
                // GivenQTY:itemchild.givenQTY,
                GivenQTY: itemchild.given
                    ? itemchild.givenQTY
                        ? itemchild.givenQTY
                        : item.qtySet
                    : null,
                GivenTime: gtime,
                TestCodes: this.getTestCodesCompleted(item, itemchild),
                // GivenDateTime: itemchild.givenDateTime ? Utils.formatterToISO(itemchild.givenDateTime, Utils.getDateTimeFormat()) : null,
                ReasonCode: itemchild.reasonCode,
                AdministrationNotes: itemchild.administrationNotes,
                Signed: true, //itemchild.signed
                MetAssessment: true, // itemchild.
                Location: this.Location.code
            };

            if (this.PharmacyOption.byPassMarsSignature) {
                param.Signed = true;
            }

            this.Load = true;
            MarsService.update(itemchild.recNo, param)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        itemchild.DisaBledBtnAdm = true;
                        this.CollapseSelected = '';
                        itemchild.reviewedByName = response.data.reviewedByName;
                        itemchild.reviewedOn = response.data.reviewedOn
                            ? Utils.formatterDateTimeToString(response.data.reviewedOn)
                            : null;
                        itemchild.lastGiven = param.Given;
                        if (idCollapse !== undefined && idCollapse !== null && idCollapse !== '') {
                            if (item.isOpenCollapse) {
                                this.$root.$emit('bv::toggle::collapse', idCollapse);
                            }
                        }
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });

                        this.GetMedicationsAsync();
                    }
                    this.Load = false;
                })
                .catch(error => {
                    this.Load = false;
                    itemchild.DisaBledBtnAdm = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.NotAbleToInsert'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        SaveAdministration(item, itemchild, idCollapse, index, indexchild) {
            this.Obj1 = item;
            this.Obj2 = itemchild;
            this.CollapseSelected = idCollapse;
            this.ProcessHeaderAndDetailOrder(itemchild.given, index, indexchild);
            if (this.PharmacyOption.byPassMarsSignature) {
                if (itemchild.recNo) {
                    this.UpdateAdministration(item, itemchild, idCollapse);
                } else {
                    if (item.mode === 'PRN') {
                        this.InsertAdministration(item, itemchild, false, idCollapse);
                    } else {
                        this.UpdateAdministration(item, itemchild, idCollapse);
                    }
                }
            } else {
                if (this.$store.state.alreadyWrotePassword) {
                    if (itemchild.recNo) {
                        this.UpdateAdministration(item, itemchild, idCollapse);
                    } else {
                        if (item.mode === 'PRN') {
                            this.InsertAdministration(item, itemchild, false, idCollapse);
                        } else {
                            this.UpdateAdministration(item, itemchild, idCollapse);
                        }
                    }
                } else {
                    this.showSignPassword = true;
                }
            }
        },

        onModalPasswordResult(result) {
            let item = result.Obj1;
            let itemchild = result.Obj2;

            if (result.type === 'Sign') {
                if (result.status !== true) {
                    this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                } else {
                    this.$store.commit('setWrotePasswordMars', true);

                    item.marsAdministrations[item.marsAdministrations.length - 1].given = true;
                    item.marsAdministrations[
                        item.marsAdministrations.length - 1
                    ].givenTime = this.DateTimeNow;
                    item.marsAdministrations[item.marsAdministrations.length - 1].givenQTY =
                        itemchild.givenQTY;

                    if (itemchild.recNo) {
                        this.UpdateAdministration(item, itemchild, this.CollapseSelected);
                    } else {
                        if (item.mode === 'PRN') {
                            this.InsertAdministration(
                                item,
                                itemchild,
                                false,
                                this.CollapseSelected
                            );
                        } else {
                            this.UpdateAdministration(
                                item,
                                itemchild,
                                false,
                                this.CollapseSelected
                            );
                        }
                    }
                }
            }

            this.showSignPassword = false;
        },

        async InsertAdministration(item, itemchild, isAuto, idCollapse) {
            if (!this.validateItemChild(item, itemchild)) {
                return;
            }

            let gtime = Utils.CombineDateAndTime(
                Utils.toDate(item.adminDate, Utils.getDateTimeFormat()),
                Utils.toDate(itemchild.givenTime, 'HH:mm')
            ); //itemchild.givenTime ? Utils.formatterToISO(itemchild.givenTime, Utils.getDateTimeFormat()): null ;
            itemchild.givenQTY = itemchild.given
                ? itemchild.givenQTY
                    ? itemchild.givenQTY
                    : item.qtySet
                : null;
            let param = {
                AdminDate: item.adminDate
                    ? Utils.formatterToISO(item.adminDate, Utils.getDateTimeFormat())
                    : null,
                RecordId: item.recordId,
                AdmissionRecordId: item.admissionRecordId,
                Given: itemchild.given,
                GivenQTY: itemchild.given
                    ? itemchild.givenQTY
                        ? itemchild.givenQTY
                        : item.qtySet
                    : null,
                GivenTime: gtime,
                ReasonCode: itemchild.reasonCode,
                AdministrationNotes: itemchild.administrationNotes,
                NeedAssessment: item.needAssessment,
                TestCodes: this.getTestCodesCompleted(item, itemchild),
                Signed: true, //itemchild.signed
                MetAssessment: true, // itemchild.
                Location: this.Location.code
            };

            if (this.PharmacyOption.byPassMarsSignature) {
                param.Signed = true;
            }

            this.Load = true;
            await MarsService.add(param)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        itemchild.DisaBledBtnAdm = true;
                        itemchild.recNo = response.data.recNo;
                        itemchild.reviewedByName = response.data.reviewedByName;
                        itemchild.reviewedOn = response.data.reviewedOn
                            ? Utils.formatterDateTimeToString(response.data.reviewedOn)
                            : null;
                        itemchild.lastGiven = param.Given;
                        this.InsertStatus = true;
                        this.CollapseSelected = '';
                        if (idCollapse !== undefined && idCollapse !== null && idCollapse !== '') {
                            if (item.isOpenCollapse) {
                                this.$root.$emit('bv::toggle::collapse', idCollapse);
                            }
                        }
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });
                        this.GetMedicationsAsync();
                    } else {
                        this.InsertStatus = false;
                    }
                    this.Load = false;
                })
                .catch(error => {
                    if (isAuto) {
                        itemchild.given = null;
                        itemchild.givenTime = null;
                        itemchild.givenQTY = 0;
                    }

                    this.InsertStatus = false;
                    itemchild.DisaBledBtnAdm = false;
                    this.Load = false;
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.NotAbleToInsert'),
                            'error'
                        );
                    } else if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else if (error.response.status === 500) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.ThereWereSomeError'),
                            'error'
                        );
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    }
                });
        },

        async getPharmacyOptions() {
            await PharmacyOptionsService.getPharmacyOptions()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.PharmacyOption = response.data[0];
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.RetrieveInformation'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async GetMedications() {
            if (this.pendingChanges) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('modalMarsMed.ChangingWithoutSaving'), {
                        title: this.TitleWindow,
                        okTitle: this.$t('Shared.TitleYes'),
                        cancelTitle: this.$t('Shared.TitleNo'),
                        footerClass: 'p-2',
                        titleClass: 'modal-title modal-type-warning'
                    })
                    .then(async value => {
                        if (value) {
                            this.GetMedicationsAsync();
                        }
                    });
            } else {
                await this.GetMedicationsAsync();
            }
        },

        async GetMedicationsAsync() {
            if (this.validate_required()) {
                // if(Utils.ValidateDate(this.DateFromModal, Utils.getDateTimeFormatToIso()) && Utils.ValidateDate(this.DateToModal, Utils.getDateTimeFormatToIso())){
                this.MedList = [];
                this.Load = true;
                let param = {
                    Mode: this.mode.code,
                    PatientCode: this.PatientCode,
                    SearchCriteria: this.parameter.SearchCriteria,
                    DateFrom: this.DateFromModal,
                    DateTo: this.DateToModal,
                    Status: this.Status.code,
                    PageNumber: this.currentPage,
                    PageSize: this.perPage
                };
                await MarsService.getMedListing(param)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            response.data.forEach(function(element) {
                                element.marsAdministrations.forEach(function(item) {
                                    item.reasonCode = item.reasonCode
                                        ? item.reasonCode.trim()
                                        : null;
                                    item.reasonDescription = item.reasonDescription
                                        ? item.reasonDescription.trim()
                                        : null;
                                    item.givenTimeInvalidFeedbackMessage = '';
                                }, this);
                            });

                            this.MedList = response.data;
                            this.showEmptyRecords =
                                response.data && response.data.length === 0 ? true : false;
                            this.totalRows =
                                response.data.length > 0 ? response.data[0].maxRows : 0;
                            this.AdmRecordId =
                                response.data.length > 0 ? this.MedList[0].admissionRecordId : null;
                            this.MedList.forEach(function(element) {
                                element.isHovered = false;
                                element.isOpenCollapse = false;
                                element.marsAdministrations.forEach(function(item) {
                                    item.reasonCodeModel = this.ReasonList.find(
                                        x => x.code == item.reasonCode
                                    );
                                }, this);

                                if (element.adminDate)
                                    element.adminDate = Utils.formatterDateToString(
                                        element.adminDate
                                    );
                                if (element.adminTime)
                                    element.adminTime = Utils.formatTime(element.adminTime);
                                if (element.dateTimeExpired)
                                    element.dateTimeExpired = Utils.formatterDateTimeToString(
                                        element.dateTimeExpired
                                    );

                                if (element.mode === 'PRN') {
                                    for (var i = 0; i < element.assessmentTypes.length; i++) {
                                        element.assessmentTypes[i].metAssessment = false;
                                    }
                                    //   if(element.marsAdministrations.length === 0){
                                    /*if (this.CanAddNewPRN(element)) {
                                    element.marsAdministrations.unshift(
                                    {
                                        isNewAdm:true,
                                        administrationNotes:"",
                                        administrationStatus: "",
                                        administrationStatusTranslated:"",
                                        expiredAdministration:false,
                                        given:null,
                                        givenDate:null,
                                        givenQTY:null,
                                        givenTime:null,
                                        marsRecNo:null,
                                        assessmentDetails:element.assessmentTypes,
                                        //metAssessment:element.needAssessment ? false : true,
                                        metAssessment:true,
                                        reasonCode:null,
                                        reasonDescription:null,
                                        reviewedByName:"",
                                        reviewedOn:null,
                                        signed:true,
                                    });
                                }*/
                                }
                            }, this);

                            setTimeout(
                                () => {
                                    this.MedList.forEach(function(element) {
                                        if (element.mode === 'PRN' && this.CanAddNewPRN(element)) {
                                            element.marsAdministrations.unshift({
                                                isNewAdm: true,
                                                administrationNotes: '',
                                                administrationStatus: '',
                                                administrationStatusTranslated: '',
                                                expiredAdministration: false,
                                                given: null,
                                                givenDate: null,
                                                givenQTY: null,
                                                givenTime: null,
                                                marsRecNo: null,
                                                assessmentDetails: element.assessmentTypes,
                                                //metAssessment:element.needAssessment ? false : true,
                                                metAssessment: true,
                                                reasonCode: null,
                                                reasonDescription: null,
                                                reviewedByName: '',
                                                reviewedOn: null,
                                                signed: true,
                                                reason: { code: '', name: '' },
                                                reasonCodeModel: null,
                                                lastGiven: null,
                                                givenTimeInvalidFeedbackMessage: ''
                                            });
                                        }
                                    }, this);
                                },
                                10,
                                this
                            );

                            this.PopulateUndoAdm();
                        }
                        //this.$emit('load', false);
                        this.Load = false;
                        this.pendingChanges = false;
                    })
                    .catch(error => {
                        //this.$emit('load', false);
                        this.Load = false;
                        if (!error.response) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('Msg.retrieveInfo'),
                                'error'
                            );
                        } else if (error.response.status === 400) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                error.response.data.errorMessage,
                                'error'
                            );
                        } else if (error.response.status === 500) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('Msg.ThereWereSomeError'),
                                'error'
                            );
                        } else {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                error.response.data.errorMessage,
                                'error'
                            );
                        }
                    });

                /*}else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.ITime'),"error");
            }*/
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('modalMarsMed.DateFromToRequired'),
                    'errorAutoHide'
                );
            }
        },

        label(value) {
            if (value === 'Weightlbs') {
                return this.unitSys === 'U' ? ' (lbs)' : ' (Kgs)';
            }
            if (value === 'Heightft' || value === 'HeadCirin') {
                return this.unitSys === 'U' ? ' (ft)' : ' (cm)';
            }
            return '';
        },

        emitEventCancel(event) {
            if (this.pendingChanges) {
                event.preventDefault();
                this.handleVerifyAndClose();
            } else {
                this.$emit('ModalTPMarsMed');
            }
        },

        onCancel() {
            this.deActivateModal();
        },

        emitEventOK(event /*bvModalEvent*/) {
            if (this.pendingChanges) {
                event.preventDefault();
                this.handleVerifyAndClose();
            } else {
                this.$emit('ModalTPMarsMed');
            }
        },

        handleVerifyAndClose() {
            this.$bvModal
                .msgBoxConfirm(this.$t('modalMarsMed.LeavingWithoutSaving'), {
                    title: this.TitleWindow,
                    okTitle: this.$t('Shared.TitleYes'),
                    cancelTitle: this.$t('Shared.TitleNo'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (value) {
                        this.$emit('ModalTPMarsMed');
                        this.$nextTick(() => {
                            this.$bvModal.hide(this.ModalId);
                        });
                    }
                });
        },

        checkUserAction(IdButton) {
            elemSaveBtn = document.getElementById(IdButton);
            if (elemSaveBtn !== null && elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        DisabledBtn() {
            setTimeout(() => this.DisabledAllButtons(), 1500);
        },

        DisabledAllButtons() {
            for (var i = 0; i < this.MedList.length; i++) {
                let arrMarsAdm = this.MedList[i].marsAdministrations;

                for (var j = 0; j < arrMarsAdm.length; j++) {
                    let elbtn = document.getElementById(
                        'btn_save_marsadm' + this.GetItemChildPrefix(this.MedList[i], arrMarsAdm[j])
                    );
                    elbtn.setAttribute('disabled', '');
                }
            }
        }
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                if (e.Obj1 !== undefined && e.Obj1 !== null) {
                    e.Obj1.DisaBledBtnAdm = false;
                    this.pendingChanges = e.Changed;
                }
            }.bind(this)
        );
    },

    async mounted() {
        await this.getDateTime();
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('MarsClinical')
            ? EnumService.ClinicalItems
            : [];
        this.$emit('getVisibleMenu', this.OptionsRightMenu);

        // const item = navigationCache.get();
        /*if(item){
        this.PhotoObj = item;
        this.DateToModal = new Date(item.DateTo);
        this.DateFromModal = new Date(item.DateFrom);
        this.PatientCode = item.PatientCode;
    }*/

        if (this.$route.name.includes('MarsClinical') && !this.OpenInModal) {
            this.PatientCode = this.$route.params.id;
            this.DateFromModal = this.From;
            this.DateToModal = this.To;
            this.RegistrationInfo = await this.getRegistrationInfoTitle(
                this.$route.params.recordid
            );
            this.RegistrationInfo.age =
                this.RegistrationInfo.age === 0 ? '0' : this.RegistrationInfo.age;
            this.PopulatePatientTitle();
        } else {
            this.DateFromModal = this.DFrom;
            this.DateToModal = this.DTo;
        }

        this.disableAddAllergies = this.$store.state.isUsePatientAllergies;
        this.isReadOnly = this.$store.state.isMarsEHRReadOnly;
        this.getReason();
        this.getPharmacyOptions();
        this.EmployeeCanChange();
        await this.GetMedications();

        this.unitSys = this.$store.state.companies.UnitSystem ?? 'U';
        let arr = this.MedList;
        let thats = this;
        setTimeout(
            function() {
                for (var i = 0; i < arr.length; i++) {
                    let arrMarsAdm = arr[i].marsAdministrations;

                    for (var j = 0; j < arrMarsAdm.length; j++) {
                        let elbtn = document.getElementById(
                            'btn_save_marsadm' + thats.GetItemChildPrefix(arr[i], arrMarsAdm[j])
                        );
                        elbtn.setAttribute('disabled', '');
                    }
                }
            },
            50,
            this
        );
    }
};
</script>

<style scoped>
.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img {
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0)
    );
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.no-image {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
}

.carouselPic {
    background-color: #fff !important;
    border-radius: 15px 15px 0 0;
    border: 4px solid #19bee1;
    overflow: hidden;
}
.carouselPic .carousel-item {
    background-color: #fff !important;
}
.patPhoto .carousel-description {
    color: white !important;
    background-color: #19bee1;
    border-radius: 0 0 15px 15px;
    height: 40px;
}
.patPhoto .carousel-description p {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 1;
    font-size: small;
    padding: 2px 10px 2px 10px;
}
.relocateIcon {
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed {
    position: absolute;
    top: 5px;
    right: 25px;
}

.medAdminLabel {
    padding: 0 0.8em;
    display: inline-block;
    margin-top: 0.4em;
    border-radius: 10px;
    font-variant-caps: all-small-caps;
    vertical-align: top !important;
    font-kerning: 5em;
    font-weight: bold;
    font-size: 0.8em;
    color: #fff;
}
.allergicToMed {
    background-color: #f00;
    color: #ff9;
    animation: blinking 1s linear infinite;
}
.overdue {
    background-color: var(--overdue);
}
.close-to-admin {
    background-color: var(--close-to-admin);
}
.prior-to-admin {
    background-color: var(--prior-to-admin);
}
.no-pending {
    background-color: var(--no-pending);
}

@keyframes blinking {
    0%,
    50% {
        color: #ff9;
    }
    100% {
        color: #f00;
    }
}
@keyframes fadingNow {
    0%,
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.withDot::after {
    content: '●';
    color: #f00;
    position: absolute;
    top: 4px;
    left: 14px;
    animation: fadingNow 1s infinite;
}
.greenBTN {
    background-color: #0c0 !important;
    border-radius: 15px 0 0 15px !important;
    color: #6f6 !important;
}
.greenBTN:hover {
    background-color: #0f0 !important;
    box-shadow: 0 0 5px #008300;
    color: #fff !important;
    transform: scale(1.1);
}
.redBTN {
    background-color: #c00 !important;
    border-radius: 0 15px 15px 0 !important;
    color: #f66 !important;
}
.redBTN:hover {
    background-color: #f00 !important;
    box-shadow: 0 0 5px #820000;
    color: #fff !important;
    transform: scale(1.1);
}

/* MODAL REMAKE */
/*.zebraAccordion{
    margin: 0 1em;
}*/
.resetFontSize small {
    font-size: 0.95em;
}
.zebraAccordion .zebraRow .zebraItem {
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem {
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem {
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19bee1;
    color: #fff;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #fff;
}
.zItemIcon {
    width: 15%;
    margin: 0 1%;
    display: inline;
    vertical-align: middle;
}

.zItemText {
    width: 86%;
    display: inline;
    vertical-align: middle;
}
@media (max-width: 992px) {
    .zItemIcon {
        width: 10%;
    }
    .zItemText {
        width: 75%;
    }
}
.quickSave {
    color: #19bee1;
    transition: all 0.3s ease-in-out;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.quickSave:hover {
    color: #fff;
}
.zebraAccordion .zebraRow .zebraItem small {
    font-size: 0.7em;
}
.PRNlabel {
    background-color: #6f6;
    border-radius: 10px;
    padding: 0 10px;
    color: #060 !important;
    transition: all 0.3s ease-in-out;
}
.PRNlabel:hover {
    background-color: #ff9;
}
.opAT {
    opacity: 0.5;
}
.accordionContent {
    border-top: 0;
    background: linear-gradient(173deg, #d9f4fb, #fff 30%);
    padding-top: 3em;
}

.giveMeds button {
    border: 4px solid #ffffffee;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}
.redMed {
    border-radius: 0 50px 50px 0;
    border-left: 0;
    height: 50px;
    background-color: #660000;
    background: linear-gradient(-40deg, #ff0000, #660000);
    animation: spreadShadowLast 1s ease-in-out infinite;
}
.redMed:hover {
    background-color: #ff0000;
    background: linear-gradient(-40deg, #990000, #ff0000);
}
.redMed:hover i::before {
    animation: spreadShadow 1s ease-in-out infinite;
}

.greenMed {
    border-radius: 50px 0 0 50px;
    background-color: #008236;
    height: 50px;
    background: linear-gradient(-40deg, #008236, #003300);
    border-right: 0 !important;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.greenMed i::before {
    font-size: 1.1em;
}
.greenMed:hover {
    background-color: #00cc00;
    background: linear-gradient(-40deg, #006600, #01d85b);
}
.greenMed:hover i::before {
    animation: spreadShadow 1s ease-in-out infinite;
}

.GivNeutral {
    opacity: 0.2;
}

.undoMedLeft {
    background-color: #666;
    background: linear-gradient(-40deg, #eee, #ccc);
    border: 4px solid #eee !important;
    border-right: 0 !important;
}
.undoMedLeft:hover {
    background-color: #999;
    background: linear-gradient(-40deg, #999, #ccc);
}
.undoMedRight {
    background-color: #666;
    background: linear-gradient(-40deg, #ccc, #eee);
    border: 4px solid #eee !important;
    border-left: 0 !important;
}
.undoMedRight:hover {
    background-color: #999;
    background: linear-gradient(-40deg, #ccc, #999);
}
@keyframes spreadShadow {
    0%,
    100% {
        text-shadow: 0 0 1px #00000099;
    }
    50% {
        text-shadow: 0 0 20px #000000ff;
    }
}
@keyframes spreadShadowFirst {
    0%,
    100% {
        text-shadow: 0 0 1px #ffffff;
    }
    50% {
        text-shadow: 0 0 20px #ffffff;
    }
}
@keyframes spreadShadowLast {
    0%,
    100% {
        text-shadow: 0 0 20px #ffffff, 0 0 20px #ffffff;
    }
    25% {
        text-shadow: 0 0 1px #ffffff, 0 0 1px #ffffff;
    }
}
.justSTAT {
    color: #fff;
    background-color: #bcd9e0;
    border-radius: 10px;
    padding: 0 5px;
}
.blinkingSTAT {
    color: #ff0;
    background-color: #c00;
    border-radius: 10px;
    padding: 0 5px;
    animation: blinkSTAT 1s steps(5, start) infinite;
}

.custom-carousel .carousel-control-prev,
.custom-carousel .carousel-control-next {
    display: v-bind(showArrows ? 'block': 'none');
}

@keyframes blinkSTAT {
    to {
        visibility: hidden;
    }
}

.StockInfo {
    color: #ff0000; /* Rojo puro (hexadecimal) */
    /* O podrías usar: color: red; */
    /* O podrías usar: color: rgb(255, 0, 0); */
    font-weight: bold; /* Para hacerlo más fuerte/grueso */
    /* Si quieres aún más fuerte, puedes usar font-weight: 900; */
    cursor: pointer;
}
</style>
